import React, {useEffect, useState, useRef, useCallback, useContext } from "react";
import {Navigate, useNavigate, useLocation } from 'react-router-dom'

import {ClickAwayListener, Grid, InputAdornment, FormGroup, FormControl, ListSubheader, FormControlLabel, InputLabel, MenuItem, Select, Checkbox, LinearProgress, Chip, DialogContent, makeStyles, Collapse, Button, TextField, Badge, CardActions, DialogActions, DialogContentText, Tooltip, Card, Dialog, ListItemText, CardHeader, IconButton, ListItemAvatar, Typography, CardContent, Avatar, Snackbar, List, DialogTitle, ListItem, Divider, ListItemIcon, Paper, Accordion, AccordionSummary, AccordionDetails, AccordionActions  } from '@material-ui/core';

import { LoggedContext, ProactiveContext, ParametersContext, HelperStepsContext, HelpActivatedContext, VisitIdContext, uninsuredExeptionsContext, uninsuredExeptionChosenContext, DataContext, overrideContext, DiagnosisAutocompleteContext, UnitContext, InsuranceContext, PatientInfoContext } from '../../Context'

import {Cake, Close, Lock, Send, AssignmentInd, LocationOn, TransferWithinAStation, LocationCity, Person, ContactPhone, ExpandMore, Cancel, ContactMail, PriorityHigh, } from '@material-ui/icons';

import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';

import {FaPills, FaSyringe, FaFileMedicalAlt, FaFilePrescription}  from "react-icons/fa";

import { Alert, AvatarGroup  } from '@material-ui/lab';

import { Provider, ErrorBoundary, useRollbar  } from '@rollbar/react'

import {FallbackUI} from '../FallbackUI';

import {HelperPoper} from '../Prescriptions/Prescriptions'

//Import Dexie database
import db, { encryptData, decryptData, updateEncryptionKey } from '../db';

import {DemoMessage, DemoDialog} from'../MainPage/MainPage'
import { useDemoStore } from '../../Stores/demoStore'

import useStore from '../../Stores/prescriptionStore';

import {PrescriptionDashboard} from'../MainPage/Fab'

const rollbarConfig = {
  accessToken: process.env.REACT_APP_ROLLBAR_TOKEN,
  environment: process.env.REACT_APP_ROLLBAR_ENV,
}


const PatientPageChild = () => {





  // Dummy data for patient information
  const dummyPatientInfo = {
    generalInfo: {
      data: {
        lastName: "Παύλου",
        firstName: "Παύλος",
        amka: "01234567890",
        birthDate: "1980-05-15",
        address: "Αθηνών 123",
        city: "Αθήνα",
        county: "Αττική",
        country: "Ελλάδα",
        email: "paulospaulou@example.com",
        telephone: "2101234567",
        sex: { id: 1 }, // 1 for male, 2 for female
        showInfo: true,
        info: "Δοκιμαστικές πληροφορίες ασθενή",
        message: "",
        covidVaccineMessage: "Εμβολιασμένος για COVID-19",
        ekasLoss: false,
        patientPartExceptions: {
          patientPartExceptions: []
        }
      },
      Age: 43
    },
    incurances: [
      {
        socialInsurance: {
          shortName: "ΕΟΠΥΥ",
          isMilitary: false,
          isPronoia: false,
          isN4368: false,
          isRetired: false
        },
        memberType: { id: 1 },
        expiryDate: "2025-12-31"
      }
    ],
    noPaperPrescriptionConcent: { Consent: 1 },
    noPaperReferralConcent: { Consent: 1 },
    personalDoctor: 0,
    reference: false,
    patientMostUsed: {
      updated: true,
      meds: [
        {
          medicationBarcode: "12345678",
          Medication: "Παρακεταμόλη",
          Quantity_Value: 1,
          Dose_Value: "500mg",
          Dose_Unit: "tab",
          Frequency: "1x3",
          Duration_Value: 10,
          Duration_Unit: "Ημέρες",
          Diagnosis: ["Πυρετός"],
          diagnosisWithCode: [{ code: "R50.9" }],
          usedTimes: 5
        }
      ],
      exams: [
        {
          Procedure: "Γενική Αίματος",
          Diagnosis: "Προληπτικός έλεγχος",
          id: "123",
          DiagnosisWithCode: { code: "Z00.0" },
          usedTimes: 3
        }
      ]
    }
  };

  // Dummy data for prescriptions history
  const dummyPrescriptionHistory = [
    [{
      Date: "2024-02-18",
      Treatment: [
        {
          Medication: "Παρακεταμόλη 500mg",
          Quantity_Value: 1,
          Dose_Value: "500",
          Dose_Unit: "mg",
          Frequency: "1x3",
          Duration_Value: 10,
          Diagnosis: ["Πυρετός"],
          ActivationDate: Date.now()
        }
      ]
    }],
    [{
      Date: "2024-02-15",
      Test: [
        {
          Procedure: "Γενική Αίματος",
          Diagnosis: "Προληπτικός έλεγχος",
          ActivationDate: Date.now() - 86400000
        }
      ]
    }]
  ];
  

  // Dummy data for regular patient medical history
  const dummyRegularPatient = {
    eMail: "gpapadopoulos@example.com",
    telephone: "2101234567",
    cellphone: "6912345678",
    location: "Αθήνα",
    emergencyContact: "Μαρία Παπαδοπούλου",
    emergencyTelephone: "6987654321",
    address: "Αθηνών 123",
    uniqueDiagnoses: [
      {
        name: "Υπέρταση",
        code: "I10",
        manifestationsPercentage: 25,
        source: "auto"
      }
    ],
    alergies: {
      date: Date.now(),
      info: [
        {
          id: 1,
          commercialNameAllergy: "Amoxicillin",
          activeSubstanceNameAllergy: "Amoxicillin",
          allergyTypeName: "Φαρμακευτική αλλεργία",
          allergyReactionFreeText: "Δερματικό εξάνθημα",
          comment: "Σοβαρή αντίδραση",
          insertDate: "2024-01-15",
          isExpired: false,
          isCancelled: false
        }
      ]
    },
    medicalHistory: {
      documentedHistory: [
        {
          symptom: "Πονοκέφαλος",
          location: "Μετωπιαίο τμήμα, αμφοτερόπλευρα",
          character: "Σφύζων πόνος",
          timeManifestation: "2024-02-01",
          duartionManifestation: "3 ώρες",
          contextManifestation: "Εμφανίστηκε μετά από πολύωρη εργασία στον υπολογιστή",
          aggravatingFactors: "Φωτεινό περιβάλλον, θόρυβος",
          relievingFactors: "Ξεκούραση σε σκοτεινό δωμάτιο, παρακεταμόλη",
          associatedSymptoms: "Ναυτία, φωτοφοβία",
          clinicalSigns: "Καμία εστιακή νευρολογική σημειολογία",
          ROS: ["Κεφαλαλγία", "Ναυτία", "Φωτοφοβία"],
          date: "2024-02-01",
          timestamp: Date.now() - 18*24*60*60*1000
        },
        {
          symptom: "Οσφυαλγία",
          location: "Οσφυϊκή μοίρα σπονδυλικής στήλης",
          character: "Αμβλύς πόνος",
          timeManifestation: "2024-01-15",
          duartionManifestation: "5 ημέρες",
          contextManifestation: "Έναρξη μετά από άρση βάρους",
          aggravatingFactors: "Κάμψη, παρατεταμένη καθιστική θέση",
          relievingFactors: "Ανάπαυση, αντιφλεγμονώδη",
          associatedSymptoms: "Μυϊκή δυσκαμψία",
          clinicalSigns: "Περιορισμός εύρους κίνησης, μυϊκός σπασμός παρασπονδυλικών μυών",
          ROS: ["Μυοσκελετικό άλγος", "Δυσκαμψία"],
          date: "2024-01-15",
          timestamp: Date.now() - 35*24*60*60*1000
        },
        {
          symptom: "Δύσπνοια",
          location: "Θώρακας",
          character: "Προοδευτικά επιδεινούμενη",
          timeManifestation: "2023-12-20",
          duartionManifestation: "2 εβδομάδες",
          contextManifestation: "Χειρότερα στην άσκηση",
          aggravatingFactors: "Σωματική δραστηριότητα, ανάβαση σκάλας",
          relievingFactors: "Ανάπαυση",
          associatedSymptoms: "Βήχας, κόπωση",
          clinicalSigns: "Ταχύπνοια, συριγμός κατά την ακρόαση",
          ROS: ["Δύσπνοια", "Βήχας", "Κόπωση"],
          date: "2023-12-20",
          timestamp: Date.now() - 61*24*60*60*1000
        },
        {
          symptom: "Γαστρεντερικές διαταραχές",
          location: "Επιγάστριο",
          character: "Καυστικός πόνος",
          timeManifestation: "2023-11-10",
          duartionManifestation: "4 ημέρες",
          contextManifestation: "Μετά από λήψη τροφής",
          aggravatingFactors: "Πικάντικα φαγητά, καφές",
          relievingFactors: "Αντιόξινα, ελαφριά διατροφή",
          associatedSymptoms: "Ναυτία, όξινες ερυγές",
          clinicalSigns: "Ευαισθησία στην ψηλάφηση επιγαστρίου",
          ROS: ["Επιγαστραλγία", "Ναυτία", "Όξινες ερυγές"],
          date: "2023-11-10",
          timestamp: Date.now() - 101*24*60*60*1000
        }
      ],

      BMI: {
        bmi: "24.5",
        weight: "75",
        height: "175"
      },
      BP: {
        category: "Φυσιολογική",
        diastolic: "80",
        systolic: "120"
      },
      hospitalizations: [
        {
          from: "2023-12-01",
          to: "2023-12-05",
          hospital: "Γενικό Νοσοκομείο Αθηνών",
          performingDoctor: "Δρ. Αναστασίου",
          reason: "Σκωληκοειδίτιδα",
          complications: "Καμία",
          id: Date.now()
        }
      ],
      vaccinations: [
        {
          name: "Γρίπης",
          performed: "Ναι"
        },
        {
          name: "COVID-19",
          performed: "Ναι"
        }
      ],
      familyHistory: [
        {
          name: "Διαβήτης",
          description: "Πατέρας"
        }
      ],
      socialHistory: [
        {
          name: "Κάπνισμα",
          description: "Μη καπνιστής"
        }
      ]
    },
    NONchronicMedsDistinct: [
      {
        Medication: "Παρακεταμόλη",
        activeSubstanceName: "Paracetamol",
        Diagnosis: ["Πυρετός"],
        ActivationDate: Date.now() - 86400000
      }
    ],
    tests: [
      {
        id: 1,
        Procedure: "Γενική Αίματος",
        Diagnosis: "Προληπτικός έλεγχος",
        DiagnosisWithCode: { code: "Z00.0" },
        activationDate: Date.now() - 86400000
      }
    ],
    data: dummyPrescriptionHistory,
    update: Date.now()
  };

  // Function to replace fetch calls with dummy data
  function mockPatientData() {
    // Replace getPatient() with:
    setOpenAddPatient(dummyRegularPatient);
    dexieUpdate.current = {
      demographics: {
        eMail: dummyRegularPatient.eMail,
        telephone: dummyRegularPatient.telephone,
        cellphone: dummyRegularPatient.cellphone,
        location: dummyRegularPatient.location,
        emergencyContact: dummyRegularPatient.emergencyContact,
        emergencyTelephone: dummyRegularPatient.emergencyTelephone,
        address: dummyRegularPatient.address
      },
      alergies: dummyRegularPatient.alergies,
      diagnoses: dummyRegularPatient.uniqueDiagnoses,
      medicalHistory: dummyRegularPatient.medicalHistory
    };
  }

  // Function to replace patient history fetch
  function mockPatientHistory(fullHistory = false) {
    setPatientHistoryByDoctor({
      status: true,
      info: dummyPrescriptionHistory,
      loading: false
    });
  }

  // Function to replace visit opening with dummy response
  function mockOpenVisit() {
    return {
      success: true,
      info: {
        componentOf: {
          encompassingEncounter: {
            id: [{ extension: "123456789" }]
          }
        }
      }
    };
  }








  //The chosen uninsured exeption in case on an uninsured patient
  const [selectedUninsuredExeption, setSelectedUninsuredExeption] = useContext(uninsuredExeptionChosenContext)
  //Check if the user is logged in
  const [logged, setLogged] = useContext(LoggedContext)
  //Handles tghe collapse action of the patient / drug / clinical info
  const [showInfo, setShowInfo] = useState({
    patientInfo:true,
    medicinesHistory:false,
    clinicalData:false,
    description:"Πληροφορίες ασφαλισμένου"
  })
  //The patient info
  const [patientInfo, setPatientInfo] = useContext(PatientInfoContext)
  //The selected unit
  const [selectedUnit, setSelectedUnit] = useContext(UnitContext)
  //The user data
  const [data] = useContext(DataContext)
  //The override data
  const [overrideData, setOverrideData] = useContext(overrideContext)
  //The selected insurance
  const [selectedInsurance, setSelectedInsurance]=useContext(InsuranceContext)
  //Activates the component for selecting the insurance (SelectInsurance)
  const [openMultipleInsurance,setOpenMultipleInsurance] = useState(false)
  //Activates the component for selecting the insurance exeption (SelectUninsuredExeptions)
  const [openUninsuredExeptions, setOpenUninsuredExeptions] = useState(false)
  //Activates the component for adding the patient to the regular patients
  const [addPatient, setAddPatient] = useState(false)
  //If true means that the user that is "regularPatient" has given the consent to the doctor to update his full medical information in the current visit
  const [updatePatientConsent, setUpdatePatientConsent] = useState(false)
  //The information of the regular patient
  const [openAddPatient, setOpenAddPatient] = useState(null)
  //The information about the potential error that  might occur
  const [generalInfo, setGeneralInfo] = useState({
    status:false,
    severity:'error',
    info:""
  })
  //The patient prescription history ONLY by user NOT all doctors
  const [patientHistoryByDoctor, setPatientHistoryByDoctor] = useState({
    status:false,
    info:[],
    loading:false
  })
  //Activates the "InformMilitary" component for informing the user
  const [infoMilitaryActivate, setInfoMilitaryActivate] = useState({
    status:false,
    userInformed:false
  })
  //HelpActivatedContext data the tooltips show condition
  const [helpActivatedTooltips, setHelpActivatedTooltips] = useContext(HelpActivatedContext)
  //HDIKA API parameters
  const [parameters, setParameters] = useContext(ParametersContext)
  //The information nedded after the doctor update to store to the local database (dexie)
  const dexieUpdate = useRef({
    demographics:{
      "eMail" : openAddPatient ? openAddPatient.eMail : "",
      "telephone" : openAddPatient ? openAddPatient.telephone : "",
      "cellphone" : openAddPatient ? openAddPatient.cellphone : "",
      "location" :  openAddPatient ? openAddPatient.location: "",
      "emergencyContact": openAddPatient ? openAddPatient.emergencyContact : "",
      "emergencyTelephone" : openAddPatient ? openAddPatient.emergencyTelephone : "",
      "address" : openAddPatient ? openAddPatient.address : ""
    },
    diagnoses: openAddPatient ? openAddPatient.uniqueDiagnoses : [],
    alergies : openAddPatient ? openAddPatient.alergies : {date:null,info:[]},
    medicalHistory:{
      documentedHistory : openAddPatient ? openAddPatient.medicalHistory.documentedHistory : [],
      BMI : {
        bmi : openAddPatient ? openAddPatient.medicalHistory.BMI.bmi : "",
        weight : openAddPatient ? openAddPatient.medicalHistory.BMI.weight : "",
        height : openAddPatient ? openAddPatient.medicalHistory.BMI.height : ""
      },
      BP:{
        category : openAddPatient ? openAddPatient.medicalHistory.BP.pressureCategory : "",
        diastolic : openAddPatient ? openAddPatient.medicalHistory.BP.diastolic : "",
        systolic : openAddPatient ? openAddPatient.medicalHistory.BP.systolic : ""
      },
      hospitalizations : openAddPatient ? openAddPatient.medicalHistory.hospitalizations : [],
      vaccinations : openAddPatient ? openAddPatient.medicalHistory.vaccinations : [],
      familyHistory: openAddPatient ? openAddPatient.medicalHistory.familyHistory : [],
      socialHistory: openAddPatient ? openAddPatient.medicalHistory.socialHistory : []
    }
  })
  //The aborter for the getPatientHistory() call
  const abortControllerPatientHistory = useRef(null)
  const rollbar = useRollbar()
  const location = useLocation()
  const [steps, setSteps] = useContext(HelperStepsContext)
  //If openedVisit===true , then the user has navigated from prescription/ reference/ refferal page back to prescription page to check patient medical reecord
  const openedVisit = location.state
  //The possible selection for the user to choose in case of an uninsured patient
  const [uninsuredExeptions, setUninsuredExeptions] = useContext(uninsuredExeptionsContext)
  
  // Initialize with dummyPatientInfo if empty
  useEffect(() => {
    if (!patientInfo) {
      setPatientInfo(dummyPatientInfo);
    }
  }, []);
 

  console.log(patientInfo)



  //CSS
  const useStyles = makeStyles((theme) => ({
    card:{
      marginTop: "1rem"
    },
    cardHeader :{
      backgroundColor: "#9fa8da",
      color:"#FFFFFF"
    },
    list:{
      overflowWrap: "anywhere"
    },
    contact: {
      backgroundColor: "#FFFFFF",
    },
    cardContent:{
      backgroundColor: "#f5f5f5",
    },
    icon:{
      fontSize: 27,
      color:"#FFFFFF"
    },
    buttonRight:{
      marginRight:"1rem",
      marginTop: window.innerWidth < 785 && "1rem",
      backgroundColor:"#7986cb"
    },
    buttonExit:{
      marginRight:"1rem",
      marginTop: window.innerWidth < 785 && "1rem"
    },
    textField:{
      marginTop:"1rem"
    },
    chip:{
      marginBottom:"1rem",
      marginRight:"1rem",
      textOverflow: 'ellipsis',
      maxWidth:'300px'
    },
    Ros:{
      marginTop:"1rem"
    }

  }))
  const classes = useStyles()




  const getPatient =  () => {
    try {
      setOpenAddPatient(dummyRegularPatient);
      dexieUpdate.current = {
        demographics: {
          eMail: dummyRegularPatient.eMail,
          telephone: dummyRegularPatient.telephone,
          cellphone: dummyRegularPatient.cellphone,
          location: dummyRegularPatient.location,
          emergencyContact: dummyRegularPatient.emergencyContact,
          emergencyTelephone: dummyRegularPatient.emergencyTelephone,
          address: dummyRegularPatient.address
        },
        alergies: dummyRegularPatient.alergies,
        diagnoses: dummyRegularPatient.uniqueDiagnoses,
        medicalHistory: dummyRegularPatient.medicalHistory
      };
    } catch (error) {
      console.error(error);
      setGeneralInfo({
        status: true,
        severity: 'error',
        info: "Σφάλμα κατά την ανάκτηση δεδομένων ασθενή"
      });
    }
  };
  //get the patient medication history ONLY by the user, NOT all doctors. Z is used for the number of years searching back
  const getPatientHistory =  (fullHistory = false) => {
    try {
      setPatientHistoryByDoctor({
        status: true,
        info: dummyPrescriptionHistory,
        loading: false
      });
    } catch (error) {
      console.error(error);
      setGeneralInfo({
        status: true,
        severity: 'error',
        info: "Σφάλμα κατά την ανάκτηση ιστορικού ασθενή"
      });
    }
  };
  



  //If the patient is military and the unit is NOT, activate message
  useEffect(() => {
    if(selectedInsurance && selectedUnit && !openedVisit){

      if(selectedInsurance.socialInsurance.isMilitary && (selectedUnit.healthCareUnit.unitType.isMilitary===false || selectedUnit.healthCareUnit.unitType.isMilitary==="") && selectedInsurance.memberType.id===1) {
        setInfoMilitaryActivate({
          status:true,
          userInformed:false
        })
      }
      else{
        setInfoMilitaryActivate({
          status:false,
          userInformed:true
        })
      }
    }
  }, [selectedInsurance])
  //If the patient has multiple insurances open the "SelectIncurance" dialog
  useEffect(() => {

    setSelectedInsurance (dummyPatientInfo.incurances[0])
   
  }, [])
  //If the patient is uninsured and the user is not his personal doctor and the doctor unit does NOT allow uninsured open the "SelectUninsuredExeptions" dialog
  useEffect(() => {

    if(selectedInsurance && selectedUnit && !openedVisit){
      if(selectedInsurance.socialInsurance.isN4368 === true && selectedUnit.healthCareUnit.unitType.canPrescribeUninsured === false) {
        //If the patient is uninsured and you are their personal physician, automatically select the "Uninsured Exception" with ID 99. This will bypass the dialog and ensure that the correct exception is applied on the Prescription and Referral page.
        if(patientInfo.personalDoctor===1){
          
          const personalDoctorSelection = uninsuredExeptions.find(x=>x.id===99)
          setSelectedUninsuredExeption(personalDoctorSelection)

        }
        else{
          setOpenUninsuredExeptions(true)
        }
      }
      else{
        setOpenUninsuredExeptions (false)
      }     
    }
  }, [selectedInsurance])





  //Check If the patient belongs to the regular patients
  useEffect(() => {

    //Before calling getPatient() make sure the user is informed in case of military and that there is a selectedInsurance, to prevent rerenders In case of uninsured exeption call getPatient() after the user has selected the uninsured exeption
    if(patientInfo?.patientMostUsed?.updated && selectedInsurance && infoMilitaryActivate.userInformed && !(selectedInsurance.socialInsurance.isN4368 === true && selectedUnit.healthCareUnit.unitType.canPrescribeUninsured === false && selectedUninsuredExeption.description==="")){
      getPatient()
    } 
    else if(openedVisit){
      getPatient()
    }
    
  }, [selectedInsurance, selectedUninsuredExeption, infoMilitaryActivate, patientInfo?.patientMostUsed?.updated])





  //Get patient most used meds and exams even if he is not added to the regular patients
  useEffect(() => {

    //Before calling getPatient() make sure the user is informed in case of military and that there is a selectedInsurance, to prevent rerenders In case of uninsured exeption call getPatient() after the user has selected the uninsured exeption
    if(patientInfo?.patientMostUsed?.updated===false && !openedVisit && selectedInsurance && infoMilitaryActivate.userInformed && !(selectedInsurance.socialInsurance.isN4368 === true && selectedUnit.healthCareUnit.unitType.canPrescribeUninsured === false && selectedUninsuredExeption.description==="")){
      getPatientHistory(false)
    } 

  }, [selectedInsurance, addPatient, openAddPatient, selectedUninsuredExeption, infoMilitaryActivate])



  /*
  Snackbar that informs the user that an error occured
  Renders a snackbar
  */
  const Info = () => {

    //Close the snackbar
    const handleClose = () => {
      setGeneralInfo({
        status:false,
        severity:'error',
        info:""
      })
    }

    return(
      <Snackbar open={generalInfo.status} onClose={handleClose}>
        <Alert 
        onClose={handleClose} 
        variant='filled'
        severity={generalInfo.severity}
        >
          {generalInfo.info}
        </Alert>
      </Snackbar>
    )
  }
  /*
  Component presents information about the patient (name, adress, ...)
  Renders 3 lists of text
  */
  const PatientInfo =()=>{

    return (
      
      selectedInsurance ?
      <>
      <Paper>
    
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
        >

        <Grid item className="patientMainInfo" lg={4}>
          
          <List
          style={{overflowWrap: "anywhere"}}
          >
            
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <Person />
                </Avatar>
              </ListItemAvatar>
              <ListItemText 
                primary={patientInfo.generalInfo.data.lastName+"  "+patientInfo.generalInfo.data.firstName} 
                secondary="Ονοματεπώνυμο" 
                primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
              />
            </ListItem>

            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <Person />
                </Avatar>
              </ListItemAvatar>
              <ListItemText 
                primary={patientInfo.generalInfo.data.amka}
                secondary="ΑΜΚΑ" 
                primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
              />
            </ListItem>
      
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <Cake />
                </Avatar>
              </ListItemAvatar>
              <ListItemText 
                primary={patientInfo.generalInfo.Age + " ετών"} 
                secondary="Ηλικία" 
                primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
              />
            </ListItem>
  
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <AssignmentInd />
                </Avatar>
              </ListItemAvatar>
              <ListItemText 
                primary={selectedInsurance.socialInsurance.shortName} 
                secondary="Ασφαλιστικός φορέας" 
                primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
              />
            </ListItem>

            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <AssignmentInd />
                </Avatar>
              </ListItemAvatar>
              <ListItemText 
                primary={patientInfo.personalDoctor===1 ? "Ασθενής που σας έχει επιλέξει ως Προσωπικό Γιατρό" : "Ο ασθενής ΔΕΝ είναι καταχωρημένος στον κατάλογο των ασθενών σας με τους οποίους έχετε σχέση προσωπικού γιατρού"} 
                secondary="Εγγεγραμμένος Ασθενής" 
                primaryTypographyProps = {{variant:'subtitle2', color: patientInfo.personalDoctor!==1 ? 'error' : 'textPrimary' }}
              />
            </ListItem>


          
          </List>

        </Grid>
        <Grid item className="patientMainInfo" lg={4}>

          <List 
          style={{overflowWrap: "anywhere"}}
          >

            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <Cake />
                </Avatar>
              </ListItemAvatar>
              <ListItemText 
                primary={patientInfo.generalInfo.data.birthDate}
                secondary="Ημ/νια γέννησης" 
                primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
              />
            </ListItem>

            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <LocationOn />
                </Avatar>
              </ListItemAvatar>
              <ListItemText 
                primary={patientInfo.generalInfo.data.address}
                secondary="Διεύθυνση κατοικίας" 
                primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
              />
            </ListItem>

            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <LocationCity />
                </Avatar>
              </ListItemAvatar>
              <ListItemText 
                primary={patientInfo.generalInfo.data.city+"  "+patientInfo.generalInfo.data.county}
                secondary="Περιοχή κατοικίας" 
                primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
              />
            </ListItem>

            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <ContactMail />
                </Avatar>
              </ListItemAvatar>
              <ListItemText 
                primary={patientInfo.generalInfo.data.email===""? "Δεν υπάρχει καταχωρημένο e-mail" : patientInfo.generalInfo.data.email}
                secondary="E-mail" 
                primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
              />
            </ListItem>

            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <ContactPhone />
                </Avatar>
              </ListItemAvatar>
              <ListItemText 
                 primary={patientInfo.generalInfo.data.telephone===""? "Δεν υπάρχει τηλέφωνο" : patientInfo.generalInfo.data.telephone}
                secondary="Τηλ. επικοινωνίας" 
                primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
              />
            </ListItem>

            {selectedInsurance.socialInsurance.isPronoia &&
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <PriorityHigh />
                </Avatar>
              </ListItemAvatar>
              <ListItemText 
                primary="Δικαιούχος πρόνοιας"
                secondary="Ιδιαίτερα χαρακτηριστικά ασφαλισης" 
                primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
              />
            </ListItem>
            }

            {selectedInsurance.socialInsurance.isN4368 &&
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <PriorityHigh />
                </Avatar>
              </ListItemAvatar>
              <ListItemText 
                primary="Δικαιούχος του Ν.4368"
                secondary="Ιδιαίτερα χαρακτηριστικά ασφαλισης" 
                primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
              />
            </ListItem>
            }

            {selectedInsurance.socialInsurance.isRetired &&
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <PriorityHigh />
                </Avatar>
              </ListItemAvatar>
              <ListItemText 
                primary="Δικαιούχος πρόνοιας"
                secondary="Συνταξιούχος" 
                primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
              />
            </ListItem>
            }

            {selectedInsurance.socialInsurance.isMilitary &&
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <PriorityHigh />
                </Avatar>
              </ListItemAvatar>
              <ListItemText 
                primary="Στρατιωτικός"
                secondary="Ιδιαίτερα χαρακτηριστικά ασφαλισης" 
                primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
              />
            </ListItem>
            }

          </List>

        </Grid>
        <Grid item className="patientMainInfo" lg={4}>
          <List
          style={{overflowWrap: "anywhere"}}
          >

            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <Send />
                </Avatar>
              </ListItemAvatar>
              <ListItemText 
                primary={patientInfo.noPaperPrescriptionConcent.Consent===0? "Άυλη συνταγογράφηση απενεργοποιημένη" : "Άυλη συνταγογράφηση ενεργοποιημένη"}
                secondary="Άυλη συνταγογράφηση" 
                primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
              />
            </ListItem>

            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <Send />
                </Avatar>
              </ListItemAvatar>
              <ListItemText 
                primary={patientInfo.noPaperReferralConcent.Consent===0? "Άυλο παραπεμπτικό απενεργοποιημένο" : "Άυλο παραπεμπτικό ενεργοποιημένο"}
                secondary="Άυλο παραπεμπτικό" 
                primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
              />
            </ListItem>

            {patientInfo.generalInfo.data.ekasLoss &&
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  0%
                </Avatar>
              </ListItemAvatar>
              <ListItemText 
                primary="Ο ασθενής έχει χάσει το ΕΚΑΣ. Προτείνεται η μηδενική συμμετοχή ασφαλισμένου στην συνταγή."
                secondary="Απώλεια ΕΚΑΣ" 
                primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
              />
            </ListItem>
            }


            {patientInfo.reference &&
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <TransferWithinAStation/>
                </Avatar>
              </ListItemAvatar>
              <ListItemText 
                primary="Ο ασθενής έχει ενεργή παραπομπή για την ειδικοτητά σας. Πριν κλείσετε την επίσκεψη του ασθενή, θα πρέπει να έχετε ολοκληρώσει την παραπομπή."
                secondary="Ενεργή παραπομπή" 
                primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
              />
            </ListItem>
            }


            {patientInfo.generalInfo.data.showInfo===true &&
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <PriorityHigh/>
                </Avatar>
              </ListItemAvatar>
              <ListItemText 
                primary={patientInfo.generalInfo.data.info}
                secondary="Πληροφορίες" 
                primaryTypographyProps = {{variant:'subtitle2', color:'secondary'}}
              />
            </ListItem>
            }

            {patientInfo.generalInfo.data.message!=="" &&
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <PriorityHigh/>
                </Avatar>
              </ListItemAvatar>
              <ListItemText 
                primary={patientInfo.generalInfo.data.message}
                secondary="Προειδοποιητικά μηνύματα που αφορούν στον ασθενή" 
                primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
              />
            </ListItem>
            }

            {patientInfo.generalInfo.data.covidVaccineMessage!=="" &&
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <PriorityHigh/>
                </Avatar>
              </ListItemAvatar>
              <ListItemText 
                
                primary={patientInfo.generalInfo.data.covidVaccineMessage}
                secondary="Προειδοποιητικά μηνύματα COVID" 
                primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
              />
            </ListItem>
            }

      
            
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  0%
                </Avatar>
              </ListItemAvatar>
              <ListItemText 
                primary='Καμία'
                secondary="Ενδείξεις μηδενικής συμμετοχής του ασθενή λόγω απαλλαγής ασφαλισμένου" 
                primaryTypographyProps = {{variant:'subtitle2'}}
              />
            </ListItem>

            

          
            

          </List>         
        </Grid>
        </Grid>

      </Paper>
      </>
      :
      "null"
    )
  }
  /*
  Component presents information about the patient (name, adress, ...)
  Renders a list of chips
  By clicking a chip opens the treatments and tests prescribed to the patient 
  */
  const PatientPrescriptionHistory =()=>{


    /*
    Presents all the prescriptions and referrals that was prescribed to the patient in a day'
    Renders a list
    */
    const Day = (props) =>{

     

      //The medicines and test prescribed to the patient in a day
      const [infoDay, setInfoDay] = useState({
        medicines:[],
        tests:[],
        date:""
      })
      //The "collapse" state
      const [openDay, setOpenDay] = useState(false)

      //Sort treatments and tests and update "infoDay"
      useEffect(() => {

        const medicine = []
        const test = []

        for (let i = 0; i < props.props.length; i++) {
          if(props.props[i].Treatment){
            medicine.push(props.props[i].Treatment)
          }
          else if(props.props[i].Test){
            test.push(props.props[i].Test)
          }
        }

        setInfoDay({
          medicines:medicine.flat(),
          tests:test.flat(),
          date:props.props[0].Date
        })

      },[])

      //Handles the "collapse" state
      const handleClickHistory = () => {
        setOpenDay(true)
      }
      //Close dialog
      const handleClose = () => {
        setOpenDay(false)
      }



      //Component that presents the medicines of the day
      const Medicines = (props) =>{

        //Opens / Closes the "collapse" part of the list item
        const [open, setOpen] = useState(false)
        
        
        //Handles the "open" state
        const handleClick = () => {
          setOpen(!open);
        }
        
        //Component that present the diagnosis of the medicine
        const Diagnoses = (props) => {
          return(
            <ListItem>
              <ListItemText 
              primary={props.props}
              secondary="Διαγνώση"
              primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
              secondaryTypographyProps = {{variant:'caption' , color:'textSecondary'}} 
              />
            </ListItem>
          )
        }

        return(
          <div className= "dayPrescriptionReferalPresentation" >
            <Tooltip
            title= {!helpActivatedTooltips ?
            <React.Fragment>
                <Typography variant='subtitle2' color="inherit">Πατήστε στο φάρμακο για να δείτε επιπλέον πληροφορίες, όπως θεραπευτικό σχήμα και διάγνωση που χρησιμοποιήθηκε.</Typography>
            </React.Fragment>
            :''} 
            >
              <ListItem button onClick={handleClick}>
                <ListItemIcon>
                  <FaPills style={{ fontSize: 25, color:"#3f51b5" }}/>
                </ListItemIcon>
                <ListItemText 
                primary={<strong>{props.props.Medication}</strong>} 
                primaryTypographyProps ={{variant:'body2'}} />
              </ListItem>
            </Tooltip>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <ListItem>
                  <ListItemText 
                  primary={props.props.Quantity_Value} 
                  secondary="Εμβαλάγεια"
                  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
                  secondaryTypographyProps = {{variant:'caption' , color:'textSecondary'}} 
                  />
                </ListItem>
                <ListItem>
                  <ListItemText 
                  primary={`${props.props.Dose_Value}  ${props.props.Dose_Unit}`}
                  secondary="Δόση"
                  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
                  secondaryTypographyProps = {{variant:'caption' , color:'textSecondary'}} 
                  />
                </ListItem>
                <ListItem>
                  <ListItemText 
                  primary={`${props.props.Frequency} για ${props.props.Duration_Value} ημέρες.`}
                  secondary="Συχνότητα"
                  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
                  secondaryTypographyProps = {{variant:'caption' , color:'textSecondary'}} 
                  />
                </ListItem>
                {props.props.Diagnosis.map((d,index) => <Diagnoses key ={index} props={d} />)}
                </Collapse>
            <Divider/>
          </div>
        )
      }
      //Component that presents the tests of the day
      const Tests = (props) =>{

        //Opens / Closes the "collapse" part of the list item
        const [open, setOpen] = useState(false);

        //Handles the "open" state
        const handleClick = () => {
          setOpen(!open);
        }

        return(
          <>
            <Tooltip
            title= {!helpActivatedTooltips ?
            <React.Fragment>
                <Typography variant='subtitle2' color="inherit">Κάνοντας κλικ στην εξέταση, μπορείτε να δείτε τη διάγνωση που χρησιμοποιήθηκε.</Typography>
            </React.Fragment>
            :''} 
            >
              <ListItem className= "dayPrescriptionReferalPresentation" button onClick={handleClick}>
                <ListItemIcon>
                  <FaSyringe style={{ fontSize: 25, color:"#e91e63" }}/>
                </ListItemIcon>
                <ListItemText 
                primary={<strong>{props.props.Procedure}</strong>}
                primaryTypographyProps ={{variant:'body1'}} />
              </ListItem>
              </Tooltip>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <ListItem>
                  <ListItemText 
                  primary={props.props.Diagnosis}
                  secondary="Διάγνωση"
                  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
                  secondaryTypographyProps = {{variant:'caption' , color:'textSecondary'}} 
                  />
                </ListItem> 
              </Collapse>
        
            <Divider/>
          </>
        )
      }



      return(
        <>
          <Tooltip
          title= {!helpActivatedTooltips ?
          <React.Fragment>
              <Typography variant='subtitle2' color="inherit">Κάντε κλικ στην ημερομηνία για να δείτε μια λίστα με τα φάρμακα και τις εξετάσεις που καταχωρήσατε στον ασθενή εκείνη την ημέρα.</Typography>
          </React.Fragment>
          :''} 
          >
            
            <Badge className= "dayPresentation" style={{marginBottom:"1rem",marginRight:"1rem",textOverflow: 'ellipsis',maxWidth:'300px'}} badgeContent={ infoDay.medicines.length + infoDay.tests.length } color="primary">
              <Chip  variant='outlined' color="primary" clickable onClick={handleClickHistory} label={infoDay.date} />
            </Badge>
            
          </Tooltip>
          <Dialog maxWidth='md' onClose={handleClose} fullWidth={true} open={openDay} timeout="auto" >

            <DialogTitle onClose={handleClose}>
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item xs={11}>
                  <Typography variant="h6">
                    {props.props[0].Date}
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                <Tooltip title="Κλείσιμο">
                  <IconButton aria-label="close"  onClick={handleClose}>
                    <Close/>
                  </IconButton>
                  </Tooltip>
                  </Grid>
                </Grid>
            </DialogTitle>

            <DialogContent>
              {infoDay.tests.map((o,index)=>
                <Tests key={index} props={o} />
              )}

              {infoDay.medicines.map((z,index)=>
                <Medicines key={index} props={z} />
              )}
            </DialogContent>

          </Dialog>

        </>
      )
    }

    return (
        
      <CardContent className={classes.contact}>
       { patientHistoryByDoctor.loading ? 
        <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={1}
        >

          <Grid item>
            <Typography  
            color="textPrimary" 
            align="center" variant="subtitle2" >
              Φόρτωση ιστορικού ασθενή. . .
            </Typography>
          </Grid>


        </Grid>
        :    
        patientHistoryByDoctor.info.length===0 ? 
        <Typography 
        color="textSecondary" 
        align="center" 
        variant="subtitle2" >
          Δεν βρέθηκε καμία εξέταση ή φάρμακο στο ιστορικό του ασθενή...
        </Typography> 
        : 
        <div className="patientPrescriptionHistory" > 
          {patientHistoryByDoctor.info.map(x=>
          <Day key={x[0].Date} props={x} />                
          )}
        </div>
        }
      </CardContent>
    
    )

  }
  /*
  Component presents information about the patient medical history
  Rendrs a list of accordions
  Every accordion contains the info of every "PatientMedicalHistory" part example: "PatientDemographics"
  */
  const PatientMedicalHistory =()=>{

    function convertTimestampToDate(timestamp) {
      // Convert the timestamp to a Date object
      const date = new Date(parseInt(timestamp));
      
      // Get individual date components
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
  
      return `${day}-${month}-${year}`
    }

    /*
      Component presents information about the patient demographics (name, age, mail, telepgone, ...)
      Rendrs an accordion
    */
    const PatientDemographics =()=>{


      // Update the patient email
      const [eMail, setEMail] = useState(dexieUpdate.current.demographics.eMail)
      // Update the patient telephone
      const [telephone, setTelephone] = useState(dexieUpdate.current.demographics.telephone)
      // Update the patient cellPhone
      const [cellPhone, setCellPhone] = useState(dexieUpdate.current.demographics.cellphone)
      // Update the patient emergency phone
      const [emergencyPhone, setEmergencyPhone] = useState(dexieUpdate.current.demographics.emergencyTelephone)
      // Update the patient emergency contact inormation
      const [emergencyContact, setEmergencyContact] = useState(dexieUpdate.current.demographics.emergencyContact)
      // Update the patient location
      const [location, setLocation] = useState(dexieUpdate.current.demographics.location)
      // Update the patient email
      const [address, setAddress] = useState(dexieUpdate.current.demographics.address)

      //Update e mail
      const onChangeEmail = (event) => {
        setEMail(event.target.value)
      }
      //Update telephone
      const onChangeTelephone = (event) => {
        setTelephone(event.target.value)
      }
      //Update cellphone
      const onChangeCellPhone = (event) => {
        setCellPhone(event.target.value)
      }
      //Update emergency phone
      const onChangeEmergencyPhone = (event) => {
        setEmergencyPhone(event.target.value)
      }
      //Update emergency contact
      const onChangeEmergencyContact = (event) => {
        setEmergencyContact(event.target.value)
      }
      //Update patient lcation
      const onChangeLocation = (event) => {
        setLocation(event.target.value)
      }
      //Update patient address
      const onChangeAddress = (event) => {
        setAddress(event.target.value)
      }

      //Every time the user changes one of the "eMail, telephone, cellPhone, emergencyContact, emergencyPhone, location, address", update the "dexieUpdate"
      useEffect(() => {

        //Update the "dexieUpdate" ref
        dexieUpdate.current = {
          ...dexieUpdate.current,
          demographics:{
            "eMail" : eMail,
            "telephone" : telephone,
            "cellphone" : cellPhone,
            "location" : location,
            "emergencyContact":emergencyContact,
            "emergencyTelephone" : emergencyPhone,
            "address" : address
          }
        }

      },[eMail, telephone, cellPhone, emergencyContact, emergencyPhone, location, address ])

      return (
         
        
      
        <Accordion 
        className="demographics"
        TransitionProps={{ unmountOnExit: true }}
        >
        <Tooltip
        title= {!helpActivatedTooltips ?
        <React.Fragment>
            <Typography variant='subtitle2' color="inherit">Κάνοντας κλικ στην καρτέλα, μπορείτε να δείτε τις πληροφορίες επικοινωνίας και τη διεύθυνση του ασθενούς.</Typography>
        </React.Fragment>
        :''} 
        >
          <AccordionSummary
            expandIcon={<ExpandMore />}
          >
            <Typography color="textSecondary" variant="h6">
              Δημογραφικά
            </Typography>
          </AccordionSummary>
          </Tooltip>
          <AccordionDetails>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="flex-start"
            spacing={1}
          >
              <Grid item xs={12} sm={12} md={12} lg={12} xl ={12} >
                <Typography color="textSecondary" variant="subtitle2">
                  Σε περίπτωση αλλαγής στοιχείων ή αν τα στοιχεία επικοινώνίας είναι ελλιπή, παρακαλώ ενημερώστε τα δημογραφικά στοιχεία στον φάκελο του ασθενή.
                </Typography>
              </Grid>

              <Grid item xs={12} lg ={4} >
   

                <TextField className={classes.textField} id="Ονοματεπώνυμο" fullWidth label="Ονοματεπώνυμο" value={patientInfo.generalInfo.data.lastName+"  "+patientInfo.generalInfo.data.firstName} variant="outlined"/>

                <TextField className={classes.textField} id="ΑΜΚΑ" fullWidth label="ΑΜΚΑ" value={patientInfo.generalInfo.data.amka} variant="outlined" />

                <TextField className={classes.textField} id="Ηλικία" fullWidth label="Ηλικία" value={patientInfo.generalInfo.Age + " ετών"} variant="outlined" />

                <TextField className={classes.textField} id="Ασφαλιστικός φορέας" fullWidth label="Ασφαλιστικός φορέας" value={selectedInsurance.socialInsurance.shortName} variant="outlined" />

            
              </Grid>

              <Grid item xs={12} lg ={4} >
                

                <TextField onChange={onChangeEmail} autoComplete='off' className={classes.textField} id="E-mail" fullWidth label="E-mail" value={eMail} variant="outlined" InputLabelProps={{shrink: true}}/>

                <TextField onChange={onChangeTelephone} autoComplete='off' className={classes.textField} id="Τηλ. επικοινωνίας (σταθερό)" fullWidth label="Τηλ. επικοινωνίας (σταθερό)" value={telephone} variant="outlined" InputLabelProps={{shrink: true}}/>

                <TextField onChange={onChangeCellPhone} autoComplete='off' className={classes.textField} id="Τηλ. επικοινωνίας (κινητό)" fullWidth label="Τηλ. επικοινωνίας (κινητό)" value={cellPhone} variant="outlined" InputLabelProps={{shrink: true}}/>

                <TextField onChange={onChangeEmergencyPhone}  autoComplete='off' className={classes.textField} id="Τηλ. εκτακτης ανάγκης" fullWidth label="Τηλ. εκτακτης ανάγκης" value={emergencyPhone} variant="outlined" InputLabelProps={{shrink: true}}/>

                <TextField onChange={onChangeEmergencyContact} autoComplete='off' className={classes.textField} id="Ονοματεπώνυμο εκτακτης ανάγκης" fullWidth label="Ονοματεπώνυμο εκτακτης ανάγκης" value={emergencyContact} variant="outlined" InputLabelProps={{shrink: true}}/>
              
              </Grid>

              <Grid item xs={12} lg ={4} >

                <TextField onChange={onChangeAddress} autoComplete="off" className={classes.textField} id="Διεύθυνση κατοικίας" fullWidth label="Διεύθυνση κατοικίας" value={address} variant="outlined"  InputLabelProps={{shrink: true}}/>

                <TextField onChange={onChangeLocation} autoComplete="off" className={classes.textField} id="Περιοχή κατοικίας" fullWidth label="Περιοχή κατοικίας" value={location} variant="outlined" InputLabelProps={{shrink: true}}/>

      
              </Grid>

            </Grid>

          </AccordionDetails>

        </Accordion>
        
    


      )

    }
    /*
      Component presents the full HDIKA history for the patient
      Renders an accordion with chips
    */
    const PrescriptionHistory =()=>{

      /*
      Presents all the prescriptions and referrals that was prescribed to the patient in a day'
      Renders a list
      */
      const Day = (props) =>{

        //The medicines and test prescribed to the patient in a day
        const [infoDay, setInfoDay] = useState({
          medicines:[],
          tests:[],
          date:""
        })
        //The "collapse" state
        const [openDay, setOpenDay] = useState(false)

        //Sort treatments and tests and update "infoDay"
        useEffect(() => {

          const medicine = []
          const test = []

          for (let i = 0; i < props.props.length; i++) {
            if(props.props[i].Treatment){
              medicine.push(props.props[i].Treatment)
            }
            else if(props.props[i].Test){
              test.push(props.props[i].Test)
            }
          }

          setInfoDay({
            medicines:medicine.flat(),
            tests:test.flat(),
            date:props.props[0].Date
          })

        },[])

        //Handles the "collapse" state
        const handleClickHistory = () => {
          setOpenDay(true)
        }
        //Close dialog
        const handleClose = () => {
          setOpenDay(false)
        }



        //Component that presents the medicines of the day
        const Medicines = (props) =>{

          //Opens / Closes the "collapse" part of the list item
          const [open, setOpen] = useState(false)
          
          
          //Handles the "open" state
          const handleClick = () => {
            setOpen(!open);
          }
          
          //Component that present the diagnosis of the medicine
          const Diagnoses = (props) => {
            return(
              <ListItem>
                <ListItemText 
                primary={props.props}
                secondary="Διαγνώση"
                primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
                secondaryTypographyProps = {{variant:'caption' , color:'textSecondary'}} 
                />
              </ListItem>
            )
          }

          return(
            <div className="prescriptionHistoryFull"  >
                <Tooltip
                title= {!helpActivatedTooltips ?
                <React.Fragment>
                    <Typography variant='subtitle2' color="inherit">Πατήστε στο φάρμακο για να δείτε επιπλέον πληροφορίες, όπως θεραπευτικό σχήμα και διάγνωση που χρησιμοποιήθηκε.</Typography>
                </React.Fragment>
                :''} 
                >
                <ListItem button onClick={handleClick}>
                  <ListItemIcon>
                    <FaPills style={{ fontSize: 25, color:"#3f51b5" }}/>
                  </ListItemIcon>
                  <ListItemText 
                  primary={<strong>{props.props.Medication}</strong>} 
                  primaryTypographyProps ={{variant:'body2'}} />
                </ListItem>
                </Tooltip>
                <Collapse in={open} timeout="auto" unmountOnExit>
                  <ListItem>
                    <ListItemText 
                    primary={props.props.Quantity_Value} 
                    secondary="Εμβαλάγεια"
                    primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
                    secondaryTypographyProps = {{variant:'caption' , color:'textSecondary'}} 
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText 
                    primary={`${props.props.Dose_Value}  ${props.props.Dose_Unit}`}
                    secondary="Δόση"
                    primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
                    secondaryTypographyProps = {{variant:'caption' , color:'textSecondary'}} 
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText 
                    primary={`${props.props.Frequency} για ${props.props.Duration_Value} ημέρες.`}
                    secondary="Συχνότητα"
                    primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
                    secondaryTypographyProps = {{variant:'caption' , color:'textSecondary'}} 
                    />
                  </ListItem>
                  {props.props.Diagnosis.map((d,index) => <Diagnoses key ={index} props={d} />)}
                  </Collapse>
              <Divider/>
            </div>
          )
        }
        //Component that presents the tests of the day
        const Tests = (props) =>{

       

          //Opens / Closes the "collapse" part of the list item
          const [open, setOpen] = useState(false);

          //Handles the "open" state
          const handleClick = () => {
            setOpen(!open);
          }

          return(
            <>
                <Tooltip
                title= {!helpActivatedTooltips ?
                <React.Fragment>
                    <Typography variant='subtitle2' color="inherit">Κάνοντας κλικ στην εξέταση, μπορείτε να δείτε τη διάγνωση που χρησιμοποιήθηκε.</Typography>
                </React.Fragment>
                :''} 
                >
                <ListItem className="prescriptionHistoryFull"  button onClick={handleClick}>
                  <ListItemIcon>
                    <FaSyringe style={{ fontSize: 25, color:"#e91e63" }}/>
                  </ListItemIcon>
                  <ListItemText 
                  primary={<strong>{props.props.Procedure}</strong>}
                  primaryTypographyProps ={{variant:'body1'}} />
                </ListItem>
                </Tooltip>
                <Collapse in={open} timeout="auto" unmountOnExit>
                  <ListItem>
                    <ListItemText 
                    primary={props.props.Diagnosis}
                    secondary="Διάγνωση"
                    primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}
                    secondaryTypographyProps = {{variant:'caption' , color:'textSecondary'}} 
                    />
                  </ListItem> 
                </Collapse>
          
              <Divider/>
            </>
          )
        }



        return(
          <>
            <Tooltip
            title= {!helpActivatedTooltips ?
            <React.Fragment>
                <Typography variant='subtitle2' color="inherit">Κάντε κλικ στην ημερομηνία για να δείτε μια λίστα με τα φάρμακα και τις εξετάσεις που καταχωρήσατε στον ασθενή εκείνη την ημέρα.</Typography>
            </React.Fragment>
            :''} 
            >
              <Badge className={classes.chip} badgeContent={ infoDay.medicines.length + infoDay.tests.length } color="primary">
                <Chip  variant='outlined' color="primary" clickable onClick={handleClickHistory} label={infoDay.date} />
              </Badge>
            </Tooltip>
            <Dialog onClose={handleClose} maxWidth='md' fullWidth={true} open={openDay} timeout="auto" >

              <DialogTitle onClose={handleClose}>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Grid item xs={11}>
                    <Typography variant="h6">
                      Ημερομηνία επίσκεψης {props.props[0].Date}
                    </Typography>
                  </Grid>
                  <Grid item xs={1}>
                  <Tooltip title="Κλείσιμο">
                    <IconButton aria-label="close"  onClick={handleClose}>
                      <Close/>
                    </IconButton>
                    </Tooltip>
                    </Grid>
                  </Grid>
              </DialogTitle>

              <DialogContent>
                {infoDay.tests.map((o,index)=>
                  <Tests key={index} props={o} />
                )}

                {infoDay.medicines.map((z,index)=>
                  <Medicines key={index} props={z} />
                )}
              </DialogContent>

            </Dialog>

          </>
        )
      }

      return (
        openAddPatient ?
        <Accordion 
        className="prescriptionHistoryFull" 
        TransitionProps={{ unmountOnExit: true }}
        >
          <Tooltip
          title= {!helpActivatedTooltips ?
          <React.Fragment>
              <Typography variant='subtitle2' color="inherit">Κάνοντας κλικ στην καρτέλα, μπορείτε να δείτε όλα τα φάρμακα και εξετάσεις που έχουν καταχωρηθεί στον ασθενή, ταξινομημένα ανά ημέρα.</Typography>
          </React.Fragment>
          :''} 
          >
          <AccordionSummary
          expandIcon={<ExpandMore />}
          >
            <Typography color="textSecondary" variant="h6">
              Πλήρες ιστορικό συνταγογραφήσεων και παραπεμπτικών
            </Typography>
          </AccordionSummary>
          </Tooltip>
          <AccordionDetails>
            <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="flex-start"
            spacing={1}
            >

              <Grid item xs={12} sm={12} md={12} lg={12} xl ={12} >
                <Typography color="textSecondary" variant="subtitle2">
                  Οι παρακάτω πληροφορίες προέρχονται απο το ιστορικό συνταγογραφήσεων του ασθενή.
                </Typography>
              </Grid>

              <Grid item xs={12} lg ={12} className={classes.grid} >

                {openAddPatient.data.length?
                openAddPatient.data.map(x=> <Day key={x.ActivationDate} props={x} />)
                :
                <Typography align='center' color="secondary" variant="subtitle2">
                  Δεν υπάρχει καταγεγραμμένη καμία εξέταση και κανένα φαρμακευτικό σκεύασμα στον ασθενή. 
                </Typography>
                } 

              </Grid>

            </Grid>
          </AccordionDetails>

        </Accordion>
        :
        null
      )
    }
    /*
    Component showing the distinct medicines ever used to the patient
    Renders a list of medicines
    */
    const DistinctMedicines = ()=>{

      
      return(
        <Accordion
        className="distinctMedicines"
        TransitionProps={{ unmountOnExit: true }}
        >
          <Tooltip
          title= {!helpActivatedTooltips ?
          <React.Fragment>
              <Typography variant='subtitle2' color="inherit">Κάνοντας κλικ στην καρτέλα, μπορείτε να δείτε τα φάρμακα που έχει λάβει ο ασθενής στο παρελθόν, καθώς και τη διάγνωση για κάθε φάρμακο.</Typography>
          </React.Fragment>
          :''} 
          >
          <AccordionSummary  expandIcon={<ExpandMore />}>
            <Typography color="textSecondary" variant="h6">
              Χρησιμοποιημένα φαρμακευτικά σκευάσματα
            </Typography>
          </AccordionSummary>
          </Tooltip>
          <AccordionDetails>

          <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="flex-start"
          spacing={1}
          >

            <Grid item xs={12} sm={12} md={12} lg={12} xl ={12} >
              <Typography color="textSecondary" variant="subtitle2">
                Παρακάτω παρουσιάζονται τα φαρμακευτικά σκευάσματα που έχει λάβει ο ασθενής καθώς και η ασθένεια για την οποία τα χρησιμοποίησε. Η λίστα εμφανίζεται από το πιο χρησιμοποιημένο στο λιγότερο.
              </Typography>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl ={12} >

            {openAddPatient.NONchronicMedsDistinct.length?
              <List>
              {openAddPatient.NONchronicMedsDistinct.map((x,index)=>
                <ListItem key={index}>
                  <ListItemAvatar>
                    <Avatar>
                      {index+1}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText   
                  style={{ wordWrap: "break-word" }}    
                  secondaryTypographyProps={{variant:"caption", color:"textSecondary"}}
                  primaryTypographyProps={{variant:"subtitle2", color:"textPrimary"}}  
                  primary={x.Medication + " (" + x.activeSubstanceName +")"} 
                  secondary={
                    <>
                      Διάγνωση: {x.Diagnosis[0]} <br />
                      Ημερομηνία έκδοσης τελευταίας συνταγής: {convertTimestampToDate(x.ActivationDate)}
                    </>
                  } 
                  />
                </ListItem>
              )}
              </List>
              :
              <Typography align='center' color="secondary" variant="subtitle2">
                Δεν υπάρχει κανένα φαρμακευτικό σκεύασμα καταγεγραμμένο στον ασθενή 
              </Typography>
              } 


                
            </Grid>

          </Grid>

          </AccordionDetails>

 

        </Accordion>
      )
    }
    /*
      Component showing the distinct medicines ever used to the patient
      Renders a list of tests
    */
    const DistinctTests = ()=>{

      const [tests, setTests] = useState([])

      useEffect(() => {
        
        //The most used tests
        const mostUsedTest = openAddPatient.tests.filter(x=>x.length>2)
        //Update the "tests" 
        setTests(mostUsedTest)

      },[])
      

      return(
        <Accordion
        className="distinctTests"
        TransitionProps={{ unmountOnExit: true }}
        >
          <Tooltip
          title= {!helpActivatedTooltips ?
          <React.Fragment>
              <Typography variant='subtitle2' color="inherit">Κάνοντας κλικ στην καρτέλα, μπορείτε να δείτε όλες τις εξετάσεις που έχει υποβληθεί ο ασθενής, με τις αντίστοιχες διαγνώσεις.</Typography>
          </React.Fragment>
          :''} 
          >
          <AccordionSummary  expandIcon={<ExpandMore />}>
            <Typography color="textSecondary" variant="h6">
              Εργαστηριακοί και απεικονιστικοί έλεγχοι
            </Typography>
          </AccordionSummary>
          </Tooltip>
          <AccordionDetails>
            
            <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="flex-start"
            spacing={1}
            >

              <Grid item xs={12} sm={12} md={12} lg={12} xl ={12} >
                  <Typography color="textSecondary" variant="subtitle2">
                    Παρακάτω παρουσιάζονται οι πιο συχνοί εργαστηριακοί και απεικονιστικοί έλεγχοι που έχει υποβληθεί ο ασθενής καθώς και η αντίστοιχη ασθένεια. Η λίστα εμφανίζεται από τη πιο συχνά χρησιμοποιημένη εξέταση στη λιγότερο.
                  </Typography>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl ={12} >

                {tests.length?
                <List>
                {tests.map((x,index)=>
                  <ListItem key={index}>
                    <ListItemAvatar>
                      <Avatar>
                        {index+1}
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText 
                    style={{ wordWrap: "break-word" }}       
                    secondaryTypographyProps={{variant:"caption", color:"textSecondary"}}
                    primaryTypographyProps={{variant:"subtitle2", color:"textPrimary"}}  
                    primary={x[0].Procedure} 
                    secondary={
                    <>
                      Διάγνωση: {x[0].Diagnosis} <br />
                      Ημερομηνία έκδοσης τελευταίου παραπεμπτικού: {convertTimestampToDate(x[0].ActivationDate)}
                    </>
                  } />
                  </ListItem>
                )}
                </List>
                :
                <Typography align='center' color="secondary" variant="subtitle2">
                  Δεν υπάρχει καμία καταγεγραμμένη εξέταση στον ασθενή 
                </Typography>
                } 

              </Grid>

            </Grid>

          </AccordionDetails>

        </Accordion>
      )
    }
    /*
    The history of the patient taken by doctor every time he makes a visit
    Renders a list of chips
    By clicking the chip opens a dialog that shows the medical card of the visit
    */
    const DocumentedVisits = () => {


      //The visits 
      const [documentedVisits, setDocumentedVisits] = useState(dummyRegularPatient.medicalHistory.documentedHistory.sort((a,b) => b.timestamp - a.timestamp))

   

      //Update the documentedVisits data that are to be inserted in the local database (dexie)
      useEffect(() => {

        //Update the "dexieUpdate" ref
        dexieUpdate.current = {
          ...dexieUpdate.current, 
          medicalHistory:{
            ...dexieUpdate.current.medicalHistory, 
            documentedHistory:documentedVisits
          }
        }

      },[documentedVisits])


      const Visit = (props) => {

        const [expanded, setExpanded] = useState(false)

        //Open the visit "Dialog"
        const handleOpen = () => {
          setExpanded(true)
        }
        //Close the visit "Dialog"
        const handleClose = () => {
          setExpanded(false)
        }
        //Delete the visit"
        const handleDeleteVisitHistory = () => {

          
          //The updated array
          const updatedDocumentedHistory = documentedVisits.filter(x=>x.date !== props.props.date)
          //Update state
          setDocumentedVisits(updatedDocumentedHistory.sort((a,b) => b.timestamp - a.timestamp))
          //Close "Visit" dialog
          setExpanded(false)
        }


        return(
          <>


            <Tooltip
            title= {!helpActivatedTooltips ?
            <React.Fragment>
                <Typography variant='subtitle2' color="inherit">Κάνοντας κλικ στην ημερομηνία, μπορείτε να δείτε όλες τις πληροφορίες σχετικά με το κύριο σύμπτωμα και μια σύντομη επισκόπηση των συστημάτων.</Typography>
            </React.Fragment>
            :''} 
            >
            <Chip className="documentedVisitsDay" style={{marginBottom:"1rem",marginRight:"1rem",textOverflow: 'ellipsis',maxWidth:'300px'}} variant='outlined' color="primary" clickable onClick={handleOpen} label={props.props.date} />
            </Tooltip>
            <Dialog  maxWidth="md" open={expanded} onClose={handleClose} >

              <DialogTitle id="title">
                {props.props.date}
              </DialogTitle>

              <DialogContent>
        
                <ListItemText style={{ wordWrap: "break-word" }}  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}} secondaryTypographyProps = {{variant:'caption', color:'textSecondary'}} primary={props.props.ROS.length ? props.props.ROS.toString() : "Δεν υπάρχει καταχώρηση"}  secondary="Επισκόπηση συστημάτων" />
                <ListItemText style={{ wordWrap: "break-word" }}  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}} secondaryTypographyProps = {{variant:'caption', color:'textSecondary'}} primary={props.props.symptom !=="" ? props.props.symptom : "Δεν υπάρχει καταχώρηση"}  secondary="Σύμπτωμα" />
                <ListItemText style={{ wordWrap: "break-word" }}  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}} secondaryTypographyProps = {{variant:'caption', color:'textSecondary'}} primary={props.props.character !=="" ? props.props.character : "Δεν υπάρχει καταχώρηση"}  secondary="Χαρακτήρας συμπτώματος" />
                <ListItemText style={{ wordWrap: "break-word" }}  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}} secondaryTypographyProps = {{variant:'caption', color:'textSecondary'}} primary={props.props.location !=="" ? props.props.location : "Δεν υπάρχει καταχώρηση"}  secondary="Περιοχή συμπτώματος και αντανακλάσεις" />
                <ListItemText style={{ wordWrap: "break-word" }}  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}} secondaryTypographyProps = {{variant:'caption', color:'textSecondary'}} primary={props.props.timeManifestation !=="" ? props.props.timeManifestation : "Δεν υπάρχει καταχώρηση"}  secondary="Χρόνος εμφάνισης" />
                <ListItemText style={{ wordWrap: "break-word" }}  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}} secondaryTypographyProps = {{variant:'caption', color:'textSecondary'}} primary={props.props.duartionManifestation !=="" ? props.props.duartionManifestation : "Δεν υπάρχει καταχώρηση"}  secondary="Διάρκεια" />
                <ListItemText style={{ wordWrap: "break-word" }}  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}} secondaryTypographyProps = {{variant:'caption', color:'textSecondary'}} primary={props.props.contextManifestation !=="" ? props.props.contextManifestation : "Δεν υπάρχει καταχώρηση"}  secondary="Συνθήκες εμφάνισης" />
                <ListItemText style={{ wordWrap: "break-word" }}  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}} secondaryTypographyProps = {{variant:'caption', color:'textSecondary'}} primary={props.props.aggravatingFactors !=="" ? props.props.aggravatingFactors : "Δεν υπάρχει καταχώρηση"}  secondary="Παράγοντες επιδείνωσης" />
                <ListItemText style={{ wordWrap: "break-word" }}  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}} secondaryTypographyProps = {{variant:'caption', color:'textSecondary'}} primary={props.props.relievingFactors !=="" ? props.props.relievingFactors : "Δεν υπάρχει καταχώρηση"}  secondary="Παράγοντες βελτίωσης" />
                <ListItemText style={{ wordWrap: "break-word" }}  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}} secondaryTypographyProps = {{variant:'caption', color:'textSecondary'}} primary={props.props.associatedSymptoms !=="" ? props.props.associatedSymptoms : "Δεν υπάρχει καταχώρηση"}  secondary="Συνοδά συμπτώματα" />
                <ListItemText style={{ wordWrap: "break-word" }}  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}} secondaryTypographyProps = {{variant:'caption', color:'textSecondary'}} primary={props.props.clinicalSigns !=="" ? props.props.clinicalSigns : "Δεν υπάρχει καταχώρηση"}  secondary="Κλινικά σημεία" />

              </DialogContent>

              <DialogActions>
                <Tooltip
                title= {!helpActivatedTooltips ?
                <React.Fragment>
                    <Typography variant='subtitle2' color="inherit">Κάνοντας κλικ στην "Επιστροφή", θα μεταφερθείτε στην καρτέλα του ιατρικού ιστορικού του ασθενή.</Typography>
                </React.Fragment>
                :''} 
                >
                <Button onClick={()=>handleClose()} variant='text' color="secondary" >
                  ΕΠΙΣΤΡΟΦΗ
                </Button>
                </Tooltip>
                <Tooltip
                title= {!helpActivatedTooltips ?
                <React.Fragment>
                    <Typography variant='subtitle2' color="inherit">Κάνοντας κλικ στο κουμπί διαγραφής, η καταχώρηση του κύριου συμπτώματος θα διαγραφεί από το ιστορικό του ασθενή.</Typography>
                </React.Fragment>
                :''} 
                >
                <Button onClick={()=>handleDeleteVisitHistory()} variant='text' color="secondary" >
                  ΔΙΑΓΡΑΦΗ
                </Button>
                </Tooltip>
              </DialogActions>
            </Dialog>
          </>
        )
      }

      return(
        <Accordion
        className="documentedVisits" 
        TransitionProps={{ unmountOnExit: true }}
        >
          <Tooltip
          title= {!helpActivatedTooltips ?
          <React.Fragment>
              <Typography variant='subtitle2' color="inherit">Κάνοντας κλικ στην καρτέλα, μπορείτε να δείτε τα κύρια ενοχλήματα του ασθενή. Το ιστορικό εμφανίζεται μόνο εάν έχετε κάνει εσείς καταχώριση.</Typography>
          </React.Fragment>
          :''} 
          >
          <AccordionSummary  expandIcon={<ExpandMore />}>
            <Typography color="textSecondary" variant="h6">
              Ιστορικό κύριων ενοχλημάτων / λόγος επίσκεψης
            </Typography>
          </AccordionSummary>
          </Tooltip>
          <AccordionDetails>

            <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="flex-start"
            spacing={1}
            >

                <Grid item xs={12} sm={12} md={12} lg={12} xl ={12} >
                    <Typography color="textSecondary" variant="subtitle2">
                        Παρακάτω παρουσιάζεται με χρονολογική σειρά το ιστορικό κύριων ενοχλημάτων του ασθενή. Παρουσιάζονται οι πληροφορίες που έχουν καταχωρηθεί ΜΟΝΟ από εσάς και όχι από όλους τους ιατρούς που πιθανόν να έχει επισκευθεί ο ασθενής.
                    </Typography>
                </Grid>
               
                <Grid item xs={12} sm={12} md={12} lg={12} xl ={12} >

                  {documentedVisits.length?
                  documentedVisits.map((x,index)=> 
                    <Visit key={index} props={x}/>
                  )
                  :
                  <Typography align='center' color="secondary" variant="subtitle2">
                    Δεν υπάρχει καταγεγραμένο ιστορικό επισκέψεων στον ασθενή.
                  </Typography>
                  } 
                    
                </Grid>

            </Grid>

          </AccordionDetails>

        </Accordion>
      )
    } 
    /*
    Weight, height, BMI, blood pressure of the patient
    Renders a list of 6 textfiellds 
    */
    const Biometrics = () => {
      const [height, setHeight] = useState(dexieUpdate.current.medicalHistory.BMI.height)
      const [weight, setWeight] = useState(dexieUpdate.current.medicalHistory.BMI.weight)
      const [bmi, setBmi] = useState(dexieUpdate.current.medicalHistory.BMI.bmi) 
      const [systolic, setSystolic] = useState(dexieUpdate.current.medicalHistory.BP.systolic) 
      const [diastolic, setDiastolic] = useState(dexieUpdate.current.medicalHistory.BP.diastolic) 
      const [pressureCategory, setPressureCategory] = useState(dexieUpdate.current.medicalHistory.BP.pressureCategory)

      const handleChangeHeight = event => {
        setHeight(event.target.value)
      }
      const handleChangeWeight = event => {
        setWeight(event.target.value)
      }
      const handleChangeSystolic = event => {
        setSystolic(event.target.value)
      }
      const handleChangeDiastolic = event => {
        setDiastolic(event.target.value)
      }


      //Calculate BMI
      useEffect(() => {
        if(height && weight) {

          const value =((weight * 10000) / (height * height)).toFixed(1)

          if(value <= 18.5){
            setBmi(`Eλλειποβαρής (ΒΜΙ:${value})`)
          }
          else if(value > 18.5 && value <= 24.9){
            setBmi(`Φυσιολογικό (ΒΜΙ:${value})`)
          }
          else if(value > 24.9 && value <= 29.9){
            setBmi(`Υπέρβαρος (ΒΜΙ:${value})`)
          }
          else{
            setBmi(`Παχύσαρκος (ΒΜΙ:${value})`)
          }
        }
        else{
          setBmi(``)
        }
      },[height, weight])

      //Calculate Blood pressure category
      useEffect(() => {
        if(diastolic && systolic) {

   
 

 
          if(systolic >= 180  || diastolic >= 120){
            setPressureCategory("Υπερτασική κρίση")
          }
          else if((systolic >= 140 && systolic <= 180) || (diastolic <= 120 && diastolic >= 90 ) ){
            setPressureCategory("Υπέρταση σταδίου 2")
          }
          else if((systolic >= 130 && systolic <= 140) || (diastolic <= 90 && diastolic >= 80 ) ){
            setPressureCategory("Υπέρταση σταδίου 1")
          }
          else if((systolic >= 120 && systolic <= 130) && diastolic <= 80 ){
            setPressureCategory("Υψηλή φυσιολογική")
          }
          else if((systolic <= 120 && systolic >= 90)  && (diastolic <= 80 && diastolic >=60 )){
            setPressureCategory("Φυσιολογική")
          }
          
          else{
            setPressureCategory("Ν/Α")

            const userInfoErrorReporting = JSON.parse(localStorage.getItem('errorContactInfo'))===true ?{
              doctorSpecialty:data.data.User.doctorSpecialty.name,
              email:data.data.User.email,
              mobile:data.data.User.mobile,
              firstname:data.data.User.name.firstname,
              lastname:data.data.User.name.lastname
          }:null 
            rollbar.error("Error in 'pressure category' in PatientPage in ERx-React",{user:userInfoErrorReporting})
            
          }
          
        }
        else{
          setPressureCategory("")
        }
      },[diastolic, systolic])


      //Update the biometrics data that are to be inserted in the local database (dexie)
      useEffect(() => {

        //Update the "dexieUpdate" ref
        dexieUpdate.current = {
          ...dexieUpdate.current,
          medicalHistory:{
            ...dexieUpdate.current.medicalHistory,
            BMI:{
              bmi:bmi,
              height:height,
              weight:weight
            },
            BP:{
              category:pressureCategory,
              diastolic:diastolic,
              systolic:systolic
            }
          }
        }

      },[height, weight, bmi, systolic, diastolic, pressureCategory ])



      return(
        <Accordion
        className="biometrics" 
        TransitionProps={{ unmountOnExit: true }}
        >
          <Tooltip
          title= {!helpActivatedTooltips ?
          <React.Fragment>
              <Typography variant='subtitle2' color="inherit">Η καρτέλα σας επιτρέπει να καταχωρίσετε ή να δείτε πληροφορίες σχετικά με τους βασικους δείκτες υγείας στοιχεία του ασθενή.</Typography>
          </React.Fragment>
          :''} 
          >
            <AccordionSummary  expandIcon={<ExpandMore />}>
              <Typography color="textSecondary" variant="h6">
                Βασικοί δείκτες υγείας
              </Typography>
            </AccordionSummary>
          </Tooltip>
          <AccordionDetails>
            <Grid
            container
            direction="row"
            justifyContent="space-evenly"
            alignItems="flex-start"
            spacing={1}
            >


              <Grid 
              item 
              xs={12}
              md ={4}
              lg={2}
              >
                <TextField
                InputLabelProps={{ shrink: true }}
                fullWidth
                variant='outlined'
                type='number'
                autoComplete="off"
                id="height"
                label="Ύψος"
                value={height}
                onChange={handleChangeHeight}
                helperText="Εισάγετε το ύψος του ασθενή σε εκατοστά. πχ 180"
                />
              </Grid>

              <Grid 
              item 
              xs={12}
              md ={4}
              lg={2}
              >
                <TextField
                InputLabelProps={{ shrink: true }}
                fullWidth
                variant='outlined'
                type='number'
                autoComplete="off"
                id="weight"
                label="Βάρος"
                value={weight}
                onChange={handleChangeWeight}
                helperText="Εισάγετε το βάρος του ασθενή σε κιλά. πχ 80"
                />
              </Grid>

              <Grid 
              item 
              xs={12}
              md ={4}
              lg={2}
              >
                <TextField
                InputLabelProps={{ shrink: true }}
                fullWidth
                type='number'
                variant='outlined'
                autoComplete="off"
                id="Συστολική Πίεση"
                label="Συστολική Πίεση"
                value={systolic}
                onChange={handleChangeSystolic}
                helperText="Εισάγετε τη συστολική πίεση (μεγάλη) σε mmHg. πχ 130"
                />
              </Grid>

              <Grid 
              item 
              xs={12}
              md ={4}
              lg={2}
              >
                <TextField
                InputLabelProps={{ shrink: true }}
                fullWidth
                type='number'
                variant='outlined'
                autoComplete="off"
                id="bmi"
                label="Διαστολική Πίεση"
                value={diastolic}
                onChange={handleChangeDiastolic}
                helperText="Εισάγετε τη διαστολική πίεση (μικρή) σε mmHg. πχ 90"
                />
              </Grid>

              <Grid 
              item 
              xs={12}
              md ={4}
              lg={2}
              >
                <TextField
                InputLabelProps={{ shrink: true, readOnly: true }}
                fullWidth
                variant='outlined'
                autoComplete="off"
                id="bmi"
                label="BMI"
                value={bmi}
                />
              </Grid>

             

            </Grid>

          </AccordionDetails>

        </Accordion>
      )
    }
    /*
    The most used Diagnoses of the patient
    Renders a list of chips 
    Every chip contains the diagnosis and the %
    */
    const Diagnoses = () => {

      //The diagnoses of the patiehnt
      const [diagnoses, setDiagnoses] = useState([])
    
      //Update the "diagnoses" at the initial load
      useEffect(() => {

        //Load the most used diagnoses (more than 1%)
        const mostUsedDiagnoses = openAddPatient.uniqueDiagnoses.filter(x=>x.manifestationsPercentage > 1 || x.source === "manual" )
        setDiagnoses(mostUsedDiagnoses)
        
      },[])

      //Component that shows the diagnosis
      const Diagnosis = (props) => {

        return(
    
          <Chip avatar={ <Avatar>{props.props.manifestationsPercentage}</Avatar> } className="diagnoses"  style={{ marginBottom:"1rem",marginRight:"1rem",textOverflow: 'ellipsis',maxWidth:'300px'}} variant='outlined' color="primary" label={props.props.name} />
  
        )
      }

      return(
        <Accordion
        className="diagnoses" 
        TransitionProps={{ unmountOnExit: true }}
        >
          <Tooltip
          title= {!helpActivatedTooltips ?
          <React.Fragment>
              <Typography variant='subtitle2' color="inherit">Στην καρτέλα "Διαγνώσεις", μπορείτε να δείτε τις πιο συχνές αιτίες επίσκεψης του ασθενή στον γιατρό.</Typography>
          </React.Fragment>
          :''} 
          >
          <AccordionSummary  expandIcon={<ExpandMore />}>
            <Typography color="textSecondary" variant="h6">
              Διαγνώσεις
            </Typography>
          </AccordionSummary>
          </Tooltip>
          <AccordionDetails>

            <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="flex-start"
            spacing={1}
            >

                <Grid item xs={12} sm={12} md={12} lg={12} xl ={12} >
                    <Typography color="textSecondary" variant="subtitle2">
                        Παρακάτω παρουσιάζονται οι πιο συχνές διαγνώσεις του ασθενή, καθώς και τα εκατοστιαία ποσοστά εμφανισής τους. Οι παρακάτω πληροφορίες προέρχονται απο το ιστορικό συνταγογραφήσεων του ασθενή.
                    </Typography>
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl ={12} >


                {diagnoses.length?
                diagnoses.map((x,index)=> 
                  <Diagnosis key={index} props={x}/>
                )
                :
                <Typography align='center' color="secondary" variant="subtitle2">
                  Δεν υπάρχει καμία καταγεγραμμένη ασθένεια στον ασθενή 
                </Typography>
                } 

                    
                </Grid>

            </Grid>



          </AccordionDetails>
      
  

        </Accordion>
      )
    }
    /*
    Component (Dialog) that presents in a list the patient allergies
    Renders a list of chips
    Every chip is clicable and renders a dialog with the allergy information
    */
    const PatientAllergies = () => {


      //The loading of the patient allergies from idika
      const [loading, setLoading] = useState(false)
      //The list of the patient allergies
      const [patientAllergiesIntollerances, setPatientAllergiesIntollerances] = useState(dexieUpdate.current.alergies)
      //The information about the potential allergies error that  might occur
      const [allergiesError, setAllergiesError] = useState({
        status:false,
        info:""
      })
      //Auxilliary state to force rerender on the PatientAllergies compopnent
      const [rerender, setRerender] = useState(0)
      //The abborter for the getPatientAllergies() call
      const abortControllerPatientAllergies = useRef(null)

      
      //Function that retrieves the patient allergies
      const getPatientAllergies = async () => {

        try{

          setLoading(true)


     

          abortControllerPatientAllergies.current = new AbortController()
          const controllerId = setTimeout(() => abortControllerPatientAllergies.current.abort("autoAborted"), parseInt(process.env.REACT_APP_TIMEOUT_MULTIPLIER) * 4000)

          const response = await fetch(process.env.REACT_APP_API_URL2 + '/patient/patientAllergies' ,{ 
            method: 'post', 
            signal: abortControllerPatientAllergies.current.signal,
            headers: {"Content-Type": "application/json", "authorization" : data.token},     
            body: JSON.stringify({
              amka:patientInfo.generalInfo.data.amka
            })
          })
          clearTimeout(controllerId)


          const patientAllergiesIntollerances = await response.json()
          //Insert the update timestamp
          const alergiesData = {
            info: patientAllergiesIntollerances,
            date: Date.now()
          }
  
          //Encrypt and Update dexie and then update the states (getPatient())
          const dataToUpdate =  encryptData({...openAddPatient, alergies:alergiesData}, data.encryptionKey)
          await db.regularPatients.put({amka:patientInfo.generalInfo.data.amka, data:dataToUpdate})

          //Update dexieUpdate
          dexieUpdate.current = {...dexieUpdate.current, alergies : alergiesData }
          //Update state
          setPatientAllergiesIntollerances(alergiesData)
          
          setLoading(false)

        }
        catch (error) {
          console.log(error)
          //DO NOT Show the error to the user in case the user has manually aborted the call or has unmounted the component.In any other case DO SHOW the error.  
          if( (error.name === 'AbortError' && abortControllerPatientAllergies.current.signal.reason !== "autoAborted") === false ){
            //Send error to backend
            const userInfoErrorReporting = JSON.parse(localStorage.getItem('errorContactInfo'))===true ?{
              doctorSpecialty:data.data.User.doctorSpecialty.name,
              email:data.data.User.email,
              mobile:data.data.User.mobile,
              firstname:data.data.User.name.firstname,
              lastname:data.data.User.name.lastname
          }:null 
            rollbar.error("Error in 'getPatientAllergies()' in PatientPage in ERx-React",{error:error, user:userInfoErrorReporting})
            //Show error to user
            setAllergiesError({
              status:true,
              info:"Κάτι πήγε στραβά! Η ενημέρωση των ανεπιθύμητων ενεργειών ασθενή απέτυχε. Για να λυθεί το πρόβλημα γυρίστε στην αρχική σελίδα και αναζητήστε εκ νέου τον ασθενή."
            })
            //Stop loading
            setLoading(false)
          }
        }
      }
      //Close error snackbar
      const allergiesFeedbackErrorClose = () =>{
        setAllergiesError(false)
      }
      

   

      //Component (Accordion) that presents the information in each allergy
      const Allergy = (props) =>{
        
        const y = props.props

        const [openDialog, setOpenDialog] = useState(false)
        const [loadingCancel, setLoadingCancel] = useState(false)
        const [loadingExpire, setLoadingExpire] = useState(false)

        //The abborter for the cancelPatientAllergies() call
        const abortControllerCancel = useRef(null)
        //The abborter for the expirePatientAllergies() call
        const abortControllerExpire = useRef(null)

        //Cancells the opatient allergy
        async function cancelPatientAllergies() {
      
          try{

            setLoadingCancel(true)

            abortControllerCancel.current = new AbortController()
            const id = setTimeout(() => abortControllerCancel.current.abort("autoAborted"),parseInt(process.env.REACT_APP_TIMEOUT_MULTIPLIER) * 5000)

            const response = await fetch(process.env.REACT_APP_API_URL2 + '/patient/patientCancelAllergies' ,{ 
              method: 'post', 
              signal: abortControllerCancel.current.signal,
              headers: {"Content-Type":"application/json", "authorization":data.token},     
              body: JSON.stringify({
                amka:patientInfo.generalInfo.data.amka,
                id: y.id,
                statusChange:"isCancelled"
              })
            })
            clearTimeout(id)

            setLoadingCancel(false)

   

            if(response.status===200){
              setRerender(prev=>prev+1)
              setOpenDialog(false)
            }
            else{
              setAllergiesError({
                status:true,
                info: "Η επεξεργασια των ανεπιθύμητων ενεργειών ασθενή απέτυχε."
              })
            }

            

          }
          catch (error) {
            //DO NOT Show the error to the user in case the user has manually aborted the call or has unmounted the component.In any other case DO SHOW the error.  
            if( (error.name === 'AbortError' && abortControllerCancel.current.signal.reason !== "autoAborted") === false ){
              //Send error to backend
              const userInfoErrorReporting = JSON.parse(localStorage.getItem('errorContactInfo'))===true ?{
                doctorSpecialty:data.data.User.doctorSpecialty.name,
                email:data.data.User.email,
                mobile:data.data.User.mobile,
                firstname:data.data.User.name.firstname,
                lastname:data.data.User.name.lastname
              }:null
              rollbar.error("Error in 'cancelPatientAllergies()' in PatientPage in ERx-React",{error:error, user:userInfoErrorReporting})
              //Show error to user
              setAllergiesError({
                status:true,
                info:"Η επεξεργασια των ανεπιθύμητων ενεργειών ασθενή απέτυχε."
              })
              //Stop loading
              setLoadingCancel(false)
            }
          }
        }
        //Aborts the cancelPatientAllergies ()
        function abortCancelPatientAllergies (){
          if(abortControllerCancel.current){ 
            abortControllerCancel.current.abort("user")
          }
        }
        //Expires patient allergy
        async function expirePatientAllergies() {

          try{

            setLoadingExpire(true)

            abortControllerExpire.current = new AbortController()
            const id = setTimeout(() => abortControllerExpire.current.abort("autoAborted"), parseInt(process.env.REACT_APP_TIMEOUT_MULTIPLIER) * 5000)

            const response = await fetch(process.env.REACT_APP_API_URL2 + '/patient/patientCancelAllergies' ,{ 
            method: 'post', 
            signal: abortControllerExpire.current.signal,
            headers: {"Content-Type":"application/json", "authorization":data.token},     
            body: JSON.stringify({
                amka:patientInfo.generalInfo.data.amka,
                id: y.id,
                statusChange:"isExpired"
              })
            })
            clearTimeout(id)

            setLoadingExpire(false)
        
            if(response.status===200){
         
              setOpenDialog(false)
            }
            else{
              setAllergiesError({
                status:true,
                info: "Η επεξεργασια των ανεπιθύμητων ενεργειών ασθενή απέτυχε."
              })
            }
      
          }
          catch (error) {
            //DO NOT Show the error to the user in case the user has manually aborted the call or has unmounted the component.In any other case DO SHOW the error.  
            if( (error.name === 'AbortError' && abortControllerExpire.current.signal.reason !== "autoAborted") === false ){
              //Send error to backend
              const userInfoErrorReporting = JSON.parse(localStorage.getItem('errorContactInfo'))===true ?{
                doctorSpecialty:data.data.User.doctorSpecialty.name,
                email:data.data.User.email,
                mobile:data.data.User.mobile,
                firstname:data.data.User.name.firstname,
                lastname:data.data.User.name.lastname
              }:null
              rollbar.error("Error in 'expirePatientAllergies()' in PatientPage in ERx-React",{error:error, user:userInfoErrorReporting}) 
              //Show error to user
              setAllergiesError({
                status:true,
                info: "Η επεξεργασια των ανεπιθύμητων ενεργειών ασθενή απέτυχε."
              })
              //Stop loading
              setLoadingExpire(false)
            }
  
          }
        }
        //Aborts the expirePatientAllergies ()
        function abortExpirePatientAllergies (){
          if(abortControllerExpire.current){ 
            abortControllerExpire.current.abort("user")
          }
        }

        const handleCloseDialog = () => {
          setOpenDialog(false)
        }
        const handleOpenDialog = () => {
          setOpenDialog(true)
        }
        

        return(

          <>
            <Tooltip
            title= {!helpActivatedTooltips ?
            <React.Fragment>
                <Typography variant='subtitle2' color="inherit">Μετά την επιλογή ενός φαρμάκου, μπορείτε να δείτε πληροφορίες σχετικά με την αλλεργία, να την ακυρώσετε ή να την καταστήσετε μη ενεργή.</Typography>
            </React.Fragment>
            :''} 
            >
              <Chip 
              style={{ marginBottom:"1rem",marginRight:"1rem",textOverflow: 'ellipsis',maxWidth:'300px'}}
              variant='outlined' 
              color={ y.isExpired || y.isCancelled  ? "secondary" : "primary"}
              clickable 
              onClick={handleOpenDialog} 
              label={y.commercialNameAllergy===null ? y.activeSubstanceNameAllergy : y.commercialNameAllergy} 
              />
            </Tooltip>
            <Dialog  maxWidth='sm' fullWidth open={openDialog} timeout="auto">

              <DialogTitle onClose={handleCloseDialog}>

                <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                >

                  <Grid item xs={11}>
                    <Typography variant="h6">
                      {y.commercialNameAllergy===null ? y.activeSubstanceNameAllergy : y.commercialNameAllergy} 
                    </Typography>
                  </Grid>

                  <Grid item xs={1}>
                  <Tooltip title="Κλείσιμο">
                    <IconButton aria-label="close"  onClick={handleCloseDialog}>
                      <Close/>
                    </IconButton>
                    </Tooltip>
                  </Grid>

                  {y.isExpired &&
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" color="secondary">
                      Η αντένδειξη / αλλεργία δεν είναι σε ισχύ
                    </Typography>
                  </Grid>
                  }

                </Grid>

              </DialogTitle>

              <DialogContent>

                <List>

                  <ListItem >
                    <ListItemText style={{ wordWrap: "break-word" }} primary={y.allergyTypeName} secondary="Τύπος"  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}} secondaryTypographyProps = {{variant:'caption', color:'textSecondary'}} />
                  </ListItem>

                  <ListItem >
                    <ListItemText style={{ wordWrap: "break-word" }} primary={y.allergyReactionFreeText} secondary="Προσδιορισμός"  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}} secondaryTypographyProps = {{variant:'caption', color:'textSecondary'}} />
                  </ListItem>

                  <ListItem >
                    <ListItemText style={{ wordWrap: "break-word" }} primary={y.comment===""?"Καμία πληροφορία" : y.comment } secondary="Σχόλια"  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}} secondaryTypographyProps = {{variant:'caption', color:'textSecondary'}} />
                  </ListItem>

                  <ListItem >
                    {y.isExpired ?
                    <ListItemText primary={y.expirationDate} secondary="Ημ/νια λήξης"  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}} secondaryTypographyProps = {{variant:'caption', color:'textSecondary'}} />
                    :
                    <ListItemText primary={y.insertDate} secondary="Ημ/νια καταχώρησης"  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}} secondaryTypographyProps = {{variant:'caption', color:'textSecondary'}} />
                    }
                  </ListItem>

                  <Divider variant='middle'/>
                  <Divider variant='middle'/>
                  <Divider variant='middle'/>

                    
                  {y.patientAllergyReactions==="" ? 
                  null
                  :
                  (Array.isArray(y.patientAllergyReactions.patientAllergyReaction) ? y.patientAllergyReactions.patientAllergyReaction : [y.patientAllergyReactions.patientAllergyReaction]).map((z,index)=>
                  <div  key={index}>
                    <List
                    subheader={
                      <ListSubheader>
                      Αλλεργική αντιδράση {index + 1}
                      </ListSubheader>
                    }>
                      <ListItem >
                        <ListItemText style={{ wordWrap: "break-word" }} primary={z.allergyReaction.description} secondary="Προσδιορισμός"  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}} secondaryTypographyProps = {{variant:'caption', color:'textSecondary'}} />
                      </ListItem>

                      <ListItem >
                        <ListItemText style={{ wordWrap: "break-word" }} primary={z.freeText} secondary="Σχόλια"  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}} secondaryTypographyProps = {{variant:'caption', color:'textSecondary'}} />
                      </ListItem>
                    </List>

                    <Divider variant='middle'/>
                    <Divider variant='middle'/>
                  </div>
                  )}
                  
                </List>

              </DialogContent>

              <DialogActions>
                <Tooltip
                title= {!helpActivatedTooltips ?
                <React.Fragment>
                    <Typography variant='subtitle2' color="inherit">Κάνοντας κλικ στο κουμπί "Λήξη", η αλλεργία θα απενεργοποιηθεί.</Typography>
                </React.Fragment>
                :''} 
                >
                <Button 
                variant='outlined'    
                onClick={ ()=> loadingExpire ? abortExpirePatientAllergies() : expirePatientAllergies()}
                aria-label="ΛΗΞΗ"
                color="secondary"
                size='small'
                disabled = {y.isExpired || loadingCancel || y.isCancelled}
                >
                  {loadingExpire ? "ΑΚΥΡΩΣΗ ΔΙΑΔΙΚΑΣΙΑΣ..." : "ΛΗΞΗ" }
                </Button>
                </Tooltip>
                <Tooltip
                title= {!helpActivatedTooltips ?
                <React.Fragment>
                    <Typography variant='subtitle2' color="inherit">Κάνοντας κλικ στην "Ακύρωση", η αλλεργία ακυρώνεται.</Typography>
                </React.Fragment>
                :''} 
                >
                <Button 
                variant='outlined'    
                onClick={ ()=> loadingCancel ? abortCancelPatientAllergies() : cancelPatientAllergies()}
                aria-label="ΑΚΥΡΩΣΗ"
                color="secondary"
                size='small'
                disabled = {(Date.now() > Date.parse(y.insertDate) + 24*60*60*1000) || loadingExpire || y.isCancelled}
                >
                  {loadingCancel ? "ΑΚΥΡΩΣΗ ΔΙΑΔΙΚΑΣΙΑΣ..." : "ΑΚΥΡΩΣΗ" }
                </Button>
                </Tooltip>
              </DialogActions>

            </Dialog>

          </>

        )
      }

      return(
        <>
      
          <Accordion 
          className="patientAllergies"
          TransitionProps={{ unmountOnExit: true }}
          >
            <Tooltip
            title= {!helpActivatedTooltips ?
            <React.Fragment>
                <Typography variant='subtitle2' color="inherit">Στη καρτέλα "Αλλεργίες / Αντενδείξεις", μπορείτε να δείτε τα φάρμακα του ασθενούς στα οποία εμφανίστηκε κάποια ανεπιθύμητη ενέργεια, καθώς και την περιγραφή της ενέργειας αυτής.</Typography>
            </React.Fragment>
            :''} 
            >
              <AccordionSummary  expandIcon={<ExpandMore />}>
                <Typography color="textSecondary" variant="h6">
                  Αλλεργίες / αντενδείξεις
                </Typography>
              </AccordionSummary>
            </Tooltip>
            <AccordionDetails className={classes.content}>

            <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="flex-start"
            spacing={1}
            >

                <Grid item xs={12} sm={12} md={12} lg={12} xl ={12} >
                    <Typography color="textSecondary" variant="subtitle2">
                        Οι παρακάτω πληροφορίες προέρχονται απο το συστημα e-prescription της ΗΔΙΚΑ.
                    </Typography>
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl ={12} >

                  {loading ?
                  <Typography align="center" color="textSecondary" variant="subtitle2">
                    Ενημέρωση αλλεργίων / αντενδείξεων ...
                  </Typography>
                  :

                  patientAllergiesIntollerances.info.length?
                  <List>
                    {patientAllergiesIntollerances.info.map(y => (
                      <Allergy key={y.id} props={y}/>
                    ))}
                  </List>
                  :
                  <Typography align='center' color="secondary" variant="subtitle2">
                    Δεν υπάρχει καμία ενεργή αλλεργία / αντενδείξη στον ασθενή.
                  </Typography>
                  }

                    
                </Grid>

            </Grid>

            </AccordionDetails>

          </Accordion>

          <Snackbar open={allergiesError.status} onClose={allergiesFeedbackErrorClose}>
            <Alert  onClose={allergiesFeedbackErrorClose} variant='filled' severity="error">
              {allergiesError.info}
            </Alert>
          </Snackbar>

        </>

      )
    }
    /*
    Component to present the hospitalizations o fthe patient
    Renders a list of chips
    Every chip is clicable and renders a dialog with the hospitalization information
    Also renders a dialog for adding a hospitalization
    */
    const Hospitalizations = () => {

      //The hospitalizations of the patient
      const [hospitalizations , setHospitalizations] = useState(dexieUpdate.current.medicalHistory.hospitalizations)
      //The dialog to add hospitalizations
      const [openDialog , setOpenDialog] = useState(false)
      //The dialog to add hospitalizations
      const [input , setInput] = useState({
        from:"",
        to:"",
        hospital:"",
        performingDoctor:"",
        reason:"",
        complications:"",
        id:Date.now()
      })

      //Every time the "hospitalizations" state changes, update the dexie
      useEffect(() => {

        //Update the "dexieUpdate" ref
        dexieUpdate.current = {
          ...dexieUpdate.current,
          medicalHistory:{
            ...dexieUpdate.current.medicalHistory,
            hospitalizations:hospitalizations
          }
        }
        
      },[hospitalizations])


      //Close the dialog
      const handleExit = () => {
        setOpenDialog(false)
      }
      //Open the dialog
      const handleAdd = () => {
        setOpenDialog(true)
      }
      //Called when the user updates the input
      const handleChange = (event) => { 
        setInput({
          ...input,
          [event.target.name]:event.target.value
        })
      }
      //Update Hospitalizations and dexie
      const handleUpdate = () => {

        //Update "hospitalizations"
        setHospitalizations(prevHospitalizations => [...prevHospitalizations, input ] )
        //Close the dialog
        setOpenDialog(false)
        //Reset the input 
        setInput({
          from:"",
          to:"",
          hospital:"",
          performingDoctor:"",
          reason:"",
          complications:"",
          id:Date.now()
        })

      }

      //Component that renders the single hospitalization
      const SingleHospitalization =(props) => {

        //The dialog to open the single hospitalizations
        const [openSingleHospitalizationDialog , setSingleHospitalizationOpenDialog] = useState(false)


        //Open he dialog that presents the hospitalization info
        const handleClick = () => {
          setSingleHospitalizationOpenDialog(true)
        }
        //Close he dialog that presents the hospitalization info
        const handleExitClick = () => {
          setSingleHospitalizationOpenDialog(false)
        }
        const handleDeleteHospitalization = () => {
          setSingleHospitalizationOpenDialog(false)
          //The hospitalization after the delete
          const updatedHospitalizations  = hospitalizations.filter(x=> x.id !== props.props.id )
          //Update "hospitalizations" state after the delete
          setHospitalizations(updatedHospitalizations)         
        }

        return(

          <>

          <Chip className="hospitalizations" onClick={handleClick}  style={{ marginBottom:"1rem",marginRight:"1rem",textOverflow: 'ellipsis',maxWidth:'300px'}} variant='outlined' color = "primary"  label={props.props.from} />


          <Dialog  maxWidth="md" open={openSingleHospitalizationDialog} onClose={handleExitClick} >

            <DialogTitle id="title">
              Πληροφορίες νοσηλείας
            </DialogTitle>

            <DialogContent>

              <List  style={{ wordWrap: "break-word" }} component="nav" aria-label="main mailbox folders">
                <ListItem>
                <ListItemText primary={props.props.from === "" ? "Καμία πληροφορία" : props.props.from } secondary="Από"  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}} secondaryTypographyProps = {{variant:'caption', color:'textSecondary'}} />
                </ListItem>
                
                <ListItem>
                <ListItemText primary={props.props.to === "" ? "Καμία πληροφορία" : props.props.to } secondary="Έως"  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}} secondaryTypographyProps = {{variant:'caption', color:'textSecondary'}} />
                </ListItem>

                <ListItem>
                <ListItemText primary={props.props.hospital === "" ? "Καμία πληροφορία" : props.props.hospital } secondary="Νοσοκομείο"  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}} secondaryTypographyProps = {{variant:'caption', color:'textSecondary'}} />
                </ListItem>

                <ListItem>
                <ListItemText primary={props.props.performingDoctor === "" ? "Καμία πληροφορία" : props.props.performingDoctor } secondary="Υπεύθυνος ιατρός"  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}} secondaryTypographyProps = {{variant:'caption', color:'textSecondary'}} />
                </ListItem>

                <ListItem>
                <ListItemText primary={props.props.reason === "" ? "Καμία πληροφορία" : props.props.reason } secondary="Λόγος"  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}} secondaryTypographyProps = {{variant:'caption', color:'textSecondary'}} />
                </ListItem>

                <ListItem>
                <ListItemText primary={props.props.complications === "" ? "Καμία πληροφορία" : props.props.complications } secondary="Επιπλοκές"  primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}} secondaryTypographyProps = {{variant:'caption', color:'textSecondary'}} />
                </ListItem>
              </List>

            </DialogContent>

            <DialogActions>
              <Button  onClick={handleExitClick} variant='text' color="secondary" >
                ΕΠΙΣΤΡΟΦΗ
              </Button>
              <Button  onClick={handleDeleteHospitalization} variant='text' color="secondary" >
                ΔΙΑΓΡΑΦΗ
              </Button>
            </DialogActions>

          </Dialog>

          </>


        )
      }

      return(
          
        <>

          <Accordion
          className="hospitalizations"
          TransitionProps={{ unmountOnExit: true }}
          >
            <Tooltip
            title= {!helpActivatedTooltips ?
            <React.Fragment>
                <Typography variant='subtitle2' color="inherit">Κάνοντας κλικ στην καρτέλα "Νοσηλείες", μπορείτε να δείτε τις νοσηλείες του ασθενή σε νοσοκομεία. Μπορείτε επίσης να καταχωρήσετε νέες νοσηλείες.</Typography>
            </React.Fragment>
            :''} 
            >
            <AccordionSummary  expandIcon={<ExpandMore />}>
              <Typography color="textSecondary" variant="h6">
                Νοσηλείες
              </Typography>
            </AccordionSummary>
            </Tooltip>
            <AccordionDetails className={classes.content}>

            <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="flex-start"
            spacing={1}
            >

                <Grid item xs={12} sm={12} md={12} lg={12} xl ={12} >
                    <Typography color="textSecondary" variant="subtitle2">
                        Οι πληροφορίες προέρχονται από την δική σας καταγραφή.
                    </Typography>
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl ={12} >

                {hospitalizations.length ? 
                  <List>
                    {hospitalizations.map((y,index) => (
                      <SingleHospitalization key={index} props={y}/>
                    ))}
                  </List>
                  :
                  <Typography variant="subtitle2" color="secondary">
                    Δεν υπάρχει καταχωρημένη Νοσηλέια για τον ασθενή.
                  </Typography>
                }
                  
                </Grid>

            </Grid>




            </AccordionDetails>

            <AccordionActions>
              <Tooltip
              title= {!helpActivatedTooltips ?
              <React.Fragment>
                  <Typography variant='subtitle2' color="inherit">Για να καταχωρίσετε μια νοσηλεία, κάντε κλικ στην επιλογή "Προσθήκη".</Typography>
              </React.Fragment>
              :''} 
              >
              <Button  onClick={handleAdd} variant='outlined' color="primary" >
                ΠΡΟΣΘΗΚΗ
              </Button>
              </Tooltip>
            </AccordionActions>

          </Accordion>

          <Dialog fullWidth maxWidth="md" open={openDialog} onClose={handleExit} >

            <DialogTitle id="title">
              Προσθήκη Νοσηλείας
            </DialogTitle>

            <DialogContent>

              <form                             
              noValidate 
              onSubmit={(event) => event.preventDefault()}
              autoComplete="off">
              

              <TextField    
              className={classes.card}   
              name="from"
              fullWidth 
              type="date" 
              onChange={handleChange} 
              label="Από" 
              variant="outlined" 
              value={input.from}
              InputLabelProps={{ shrink: true }}
              />

              <TextField      
              className={classes.card} 
              name="to"
              type="date" 
              fullWidth  
              onChange={handleChange} 
              label="Έως" 
              variant="outlined" 
              value={input.to}
              InputLabelProps={{ shrink: true }}
              />

              <TextField      
              className={classes.card} 
              name="hospital"
              fullWidth  
              onChange={handleChange} 
              label="Νοσοκομείο" 
              variant="outlined" 
              value={input.hospital}
              InputLabelProps={{ shrink: true }}
              />

              <TextField     
              className={classes.card}  
              name="performingDoctor"
              fullWidth  
              onChange={handleChange} 
              label="Υπεύθυνος ιατρός" 
              variant="outlined" 
              value={input.performingDoctor}
              InputLabelProps={{ shrink: true }}
              />

              <TextField  
              className={classes.card}     
              name="reason"
              fullWidth  
              onChange={handleChange} 
              label="Αιτία νοσηλείας" 
              variant="outlined" 
              value={input.reason}
              InputLabelProps={{ shrink: true }}
              />

              <TextField   
              className={classes.card}    
              name="complications"
              fullWidth  
              onChange={handleChange} 
              label="Επιπλοκές" 
              variant="outlined" 
              value={input.complications}
              InputLabelProps={{ shrink: true }}
              />

              </form>

            </DialogContent>

            <DialogActions>
              <Button onClick={handleExit} variant='text' color="secondary" >
                ΕΠΙΣΤΡΟΦΗ
              </Button>
              <Button disabled={input.from === "" ? true : false} onClick={handleUpdate} variant='text' color="primary" >
                ΠΡΟΣΘΗΚΗ
              </Button>
            </DialogActions>

          </Dialog>

        </>

      )
    }  
    /*
    Component to present the vaccinations of the patient
    Renders a list of droplists for the user to choose the vaccination status
    */
    const Vaccinations = () => {

      //The vaccinations of the patient
      const [vaccinations , setVaccinations] = useState(dexieUpdate.current.medicalHistory.vaccinations)


      //Every time the "vaccinations" state changes, update the dexie
      useEffect(() => {

        //Update the "dexieUpdate" ref
        dexieUpdate.current = {
          ...dexieUpdate.current,
          medicalHistory:{
            ...dexieUpdate.current.medicalHistory,
            vaccinations:vaccinations
          }
        }
        
      },[vaccinations])


      //Called when the user updates the input
      const handleChange = (event) => { 

        const updatedVaccinations = vaccinations.map(x=>{
          if(x.name === event.target.name){
            return {
              name:event.target.name, 
              performed: event.target.value
            }
          }
          else{
            return x
          }
        })
        setVaccinations(updatedVaccinations)
      }

     

      return(

        <Accordion
        disabled
        className="vaccinations" 
        TransitionProps={{ unmountOnExit: true }}
        >
          <Tooltip
          title= {!helpActivatedTooltips ?
          <React.Fragment>
              <Typography variant='subtitle2' color="inherit">Η καρτέλα "Εμβολιασμοί" σας επιτρέπει να δείτε και να καταχωρήσετε τους εμβολιασμούς του ασθενή.</Typography>
          </React.Fragment>
          :''} 
          >
          <AccordionSummary  expandIcon={<ExpandMore />}>
            <Typography color="textSecondary" variant="h6">
              Εμβολιασμοί
            </Typography>
          </AccordionSummary>
          </Tooltip>
          <AccordionDetails className={classes.content}>



          <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="flex-start"
          spacing={1}
          >

              <Grid item xs={12} sm={12} md={12} lg={12} xl ={12} >
                  <Typography color="textSecondary" variant="subtitle2">
                      Οι παρακάτω πληροφορίες προέρχονται απο την δική σας καταγραφή
                  </Typography>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl ={12} >

                <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="flex-end"
                spacing={1}
                >

                  {vaccinations.map((y,index) => (
                    <Grid key={index} item xs= {12} md={6} lg={4} xl={3}>             
                      <InputLabel shrink id={y.name}>{y.name}</InputLabel>
                      <Select
                      fullWidth 
                      variant="outlined"
                      name={y.name}
                      onChange={handleChange}
                      labelId={y.name}
                      id={y.name}
                      value={y.performed}  
                      >
                        <MenuItem value="Δεν γνωρίζω">Δεν γνωρίζω</MenuItem>
                        <MenuItem value="Ναι">Ναι</MenuItem>
                        <MenuItem value="'Οχι">'Οχι</MenuItem>
                      </Select>
                    </Grid>  

                
                  ))}
                
                </Grid>

              </Grid>

          </Grid>

          </AccordionDetails>



        </Accordion>

      )
    }
    /*
    Component to present the main family history of the patient
    Renders a list of droplists for the user to choose the family history status 
    */
    const FamilyHistory = () => {

      //The vaccinations of the patient
      const [familyHistory , setFamilyHistory] = useState(dexieUpdate.current.medicalHistory.familyHistory)


      //Every time the "familyHistory" state changes, update the dexie
      useEffect(() => {

        //Update the "dexieUpdate" ref
        dexieUpdate.current = {
          ...dexieUpdate.current,
          medicalHistory:{
            ...dexieUpdate.current.medicalHistory,
            familyHistory:familyHistory
          }
        }
        
      },[familyHistory])




      //Called when the user updates the input
      const handleChange = (event) => { 

        const updatedFamilyHistory = familyHistory.map(x=>{
          if(x.name === event.target.name){
            return {
              name:event.target.name, 
              description: event.target.value
            }
          }
          else{
            return x
          }
        })
        setFamilyHistory(updatedFamilyHistory)
      }





      return(

        <Accordion
        disabled
        className="familyHistory" 
        TransitionProps={{ unmountOnExit: true }}
        >
          <Tooltip
          title= {!helpActivatedTooltips ?
          <React.Fragment>
              <Typography variant='subtitle2' color="inherit">Για να δείτε και να καταχωρίσετε το σύντομο οικογενειακό ιστορικό του ασθενούς, κάντε κλικ στην καρτέλα.</Typography>
          </React.Fragment>
          :''} 
          >
          <AccordionSummary  expandIcon={<ExpandMore />}>
            <Typography color="textSecondary" variant="h6">
              Οικογενειακό ιστορικό
            </Typography>
          </AccordionSummary>
          </Tooltip>
          <AccordionDetails className={classes.content}>

          <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="flex-start"
          spacing={1}
          >

              <Grid item xs={12} sm={12} md={12} lg={12} xl ={12} >
                  <Typography color="textSecondary" variant="subtitle2">
                      Οι παρακάτω πληροφορίες προέρχονται απο την δική σας καταγραφή
                  </Typography>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl ={12} >
                <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="flex-end"
                spacing={1}
                >

                  {familyHistory.map((y,index) => (
                    <Grid key={index} item xs= {12} md={6} lg={4} xl={3}>             
                      <InputLabel shrink id={y.name}>{y.name}</InputLabel>
                      <Select
                      fullWidth 
                      variant="outlined"
                      name={y.name}
                      onChange={handleChange}
                      labelId={y.name}
                      id={y.name}
                      value={y.description}  
                      >
                        <MenuItem value="Δεν γνωρίζω">Δεν γνωρίζω</MenuItem>
                        <MenuItem value="Κανένας">Κανένας</MenuItem>
                        <MenuItem value="Μητέρα">Μητέρα</MenuItem>
                        {(y.name !== 'Καρκίνος ωοθηκών' && y.name !== 'Καρκίνος στήθους') && <MenuItem value="Πατέρας">Πατέρας</MenuItem>}
                        {(y.name !== 'Καρκίνος ωοθηκών' && y.name !== 'Καρκίνος στήθους') && <MenuItem value="Και οι 2 γονείς">Και οι δύο γονείς</MenuItem>}
                        <MenuItem value="Αδέλφια">Αδέλφια</MenuItem>
                        <MenuItem value="Παιδιά">Παιδιά</MenuItem>
                      </Select>
                    </Grid>  

                
                  ))}
                
                </Grid>

              </Grid>

          </Grid>


  


          </AccordionDetails>



        </Accordion>

      )
    }
    /*
    Component to present the social history of the patient
    Renders a list of droplists for the user to choose the social history status 
    */
    const SocialHistory = () => {

      //The Social History of the patient
      const [socialHistory , setSocialHistory] = useState(dexieUpdate.current.medicalHistory.socialHistory )

      //Every time the "socialHistory" state changes, update the dexie
      useEffect(() => {

        //Update the "dexieUpdate" ref
        dexieUpdate.current = {
          ...dexieUpdate.current,
          medicalHistory:{
            ...dexieUpdate.current.medicalHistory,
            socialHistory:socialHistory
          }
        }
        
      },[socialHistory])


      //Called when the user updates the input
      const handleChange = (event) => { 

      const updatedSocialHistory = socialHistory.map(x=>{
          if(x.name === event.target.name){
          return {
              name:event.target.name, 
              description: event.target.value
          }
          }
          else{
          return x
          }
      })
      setSocialHistory(updatedSocialHistory)
      }


      return(

      <Accordion
      disabled
      className="socialHistory"
      TransitionProps={{ unmountOnExit: true }}
      >
        <Tooltip
        title= {!helpActivatedTooltips ?
        <React.Fragment>
            <Typography variant='subtitle2' color="inherit">Κάντε κλικ στην καρτέλα για να δείτε και να καταχωρήσετε τις πληροφορίες σχετικά με τις κοινωνικές συνήθειες του ασθενούς που ενδέχεται να επηρεάσουν την υγεία του.</Typography>
        </React.Fragment>
        :''} 
        >
        <AccordionSummary  expandIcon={<ExpandMore />}>
        <Typography color="textSecondary" variant="h6">
            Κοινωνικό ιστορικό
        </Typography>
        </AccordionSummary>
        </Tooltip>
        <AccordionDetails className={classes.content}>

          <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="flex-start"
          spacing={1}
          >

              <Grid item xs={12} sm={12} md={12} lg={12} xl ={12} >
                  <Typography color="textSecondary" variant="subtitle2">
                      Οι παρακάτω πληροφορίες προέρχονται απο την δική σας καταγραφή
                  </Typography>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl ={12} >

                {dexieUpdate.current.medicalHistory.socialHistory.length ? 
                  <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="flex-end"
                  spacing={1}
                  >

                      
                    <Grid item xs= {12} md={6} lg={4} xl={3}>             
                        <InputLabel shrink id="Κάπνισμα">Κάπνισμα</InputLabel>
                        <Select
                        fullWidth 
                        variant="outlined"
                        name="Κάπνισμα"
                        onChange={handleChange}
                        id="Κάπνισμα"
                        value={socialHistory[0].description}  
                        >
                            <MenuItem value="Δεν γνωρίζω">Δεν γνωρίζω</MenuItem>
                            <MenuItem value="Μη καπνιστής">Μη καπνιστής</MenuItem>
                            <MenuItem value="Πρώην καπνιστής">Πρώην καπνιστής</MenuItem>
                            <MenuItem value="Κάπνιστης (0-10 τσιγάρα)">Κάπνιστης-ρια (0-10 τσιγάρα)</MenuItem>
                            <MenuItem value="Κάπνιστης (10-20 τσιγάρα)">Κάπνιστης-ρια (10-20 τσιγάρα)</MenuItem>
                            <MenuItem value="Κάπνιστης (>20 τσιγάρα)">Κάπνιστης-ρια (20+ τσιγάρα)</MenuItem>
                        </Select>
                    </Grid>  

                    <Grid item xs= {12} md={6} lg={4} xl={3}>             
                        <InputLabel shrink id="Αλκοόλ (1 μερίδα = ένα κουτάκι μπύρας)">Αλκοόλ (1 μερίδα = ένα κουτάκι μπύρας)</InputLabel>
                        <Select
                        fullWidth 
                        variant="outlined"
                        name="Αλκοόλ (1 μερίδα = ένα κουτάκι μπύρας)"
                        onChange={handleChange}
                        id="Αλκοόλ (1 μερίδα = ένα κουτάκι μπύρας)"
                        value={socialHistory[1].description}  
                        >
                          <MenuItem value="Δεν γνωρίζω">Δεν γνωρίζω</MenuItem>
                          <MenuItem value="Λιγότερο από μια 1 / ημέρα">Λιγότερο από μια 1 / ημέρα</MenuItem>
                          <MenuItem value="1 μερίδα / ημέρα">1 μερίδα / ημέρα</MenuItem>
                          <MenuItem value="2-3 μερίδες / ημέρα">2-3 μερίδες / ημέρα</MenuItem>
                          <MenuItem value="Περισσότερο από 3 μερίδες / ημέρα">Περισσότερο από 3 μερίδες / ημέρα</MenuItem>
                        </Select>
                    </Grid>  

                    <Grid item xs= {12} md={6} lg={4} xl={3}>             
                      <InputLabel shrink id="Ναρκωτικά">Ναρκωτικά</InputLabel>
                      <Select
                      fullWidth 
                      variant="outlined"
                      name="Ναρκωτικά"
                      onChange={handleChange}
                      id="Ναρκωτικά"
                      value={socialHistory[2].description}  
                      >
                        <MenuItem value="Δεν γνωρίζω">Δεν γνωρίζω</MenuItem>
                        <MenuItem value="ΔΕΝ γίνεται χρήση">ΔΕΝ γίνεται χρήση</MenuItem>
                        <MenuItem value="Περιστασιακή χρήση">Περιστασιακή χρήση</MenuItem>
                        <MenuItem value="Συστηματική  χρήση">Συστηματική  χρήση</MenuItem>
                      </Select>
                    </Grid>     

                    <Grid item xs= {12} md={6} lg={4} xl={3}>             
                      <InputLabel shrink id="Ύπνος">Ύπνος</InputLabel>
                      <Select
                      fullWidth 
                      variant="outlined"
                      name="Ύπνος"
                      onChange={handleChange}
                      id="Ύπνος"
                      value={socialHistory[3].description}  
                      >
                        <MenuItem value="Δεν γνωρίζω">Δεν γνωρίζω</MenuItem>
                        <MenuItem value="4-6 ώρες">4-6 ώρες</MenuItem>
                        <MenuItem value="6-8 ώρες">6-8 ώρες</MenuItem>
                        <MenuItem value="Περισσότερο από 8 ώρες">Περισσότερο από 8 ώρες</MenuItem>
                      </Select>
                    </Grid> 

                    <Grid item xs= {12} md={6} lg={4} xl={3}>             
                      <InputLabel shrink id="Εργασία">Εργασία</InputLabel>
                      <Select
                      fullWidth 
                      variant="outlined"
                      name="Εργασία"
                      onChange={handleChange}
                      id="Εργασία"
                      value={socialHistory[4].description}  
                      >
                        <MenuItem value="Δεν γνωρίζω">Δεν γνωρίζω</MenuItem>
                        <MenuItem value="Εργαζόμενος-η">Εργαζόμενος</MenuItem>
                        <MenuItem value="Άνεργος-η">Άνεργος</MenuItem>
                      </Select>
                    </Grid> 
                    
                    <Grid item xs= {12} md={6} lg={4} xl={3}>             
                      <InputLabel shrink id="Άσκηση (Χρόνος μέτριας αεροβικής άσκησης)">Άσκηση (Χρόνος μέτριας αεροβικής άσκησης)</InputLabel>
                      <Select
                      fullWidth 
                      variant="outlined"
                      name="Άσκηση (Χρόνος μέτριας αεροβικής άσκησης)"
                      onChange={handleChange}
                      id="Άσκηση (Χρόνος μέτριας αεροβικής άσκησης)"
                      value={socialHistory[5].description}  
                      >
                        <MenuItem value="Δεν γνωρίζω">Δεν γνωρίζω</MenuItem>
                        <MenuItem value="0-20 λεπτά ">0-20 λεπτά</MenuItem>
                        <MenuItem value="20 - 40 λεπτά">20 - 40 λεπτά</MenuItem>
                        <MenuItem value="Περισσότερο από 40 λεπτά">Περισσότερο από 40 λεπτά</MenuItem>
                      </Select>
                    </Grid> 

                    <Grid item xs= {12} md={6} lg={4} xl={3}>             
                      <InputLabel shrink id="Οικογενειακή κατάσταση">Οικογενειακή κατάσταση</InputLabel>
                      <Select
                      fullWidth 
                      variant="outlined"
                      name="Οικογενειακή κατάσταση"
                      onChange={handleChange}
                      id="Οικογενειακή κατάσταση"
                      value={socialHistory[6].description}  
                      >
                        <MenuItem value="Δεν γνωρίζω">Δεν γνωρίζω</MenuItem>
                        <MenuItem value="Άγαμος-η">Άγαμος</MenuItem>
                        <MenuItem value="Έγγαμος-η">Έγγαμος</MenuItem>
                        <MenuItem value="Έγγαμος-η με παιδιά">Έγγαμος με παιδιά</MenuItem>
                      </Select>
                    </Grid> 

                    <Grid item xs= {12} md={6} lg={4} xl={3}>             
                      <InputLabel shrink id="Εκπαιδευτικό επίπεδο">Εκπαιδευτικό επίπεδο</InputLabel>
                      <Select
                      fullWidth 
                      variant="outlined"
                      name="Εκπαιδευτικό επίπεδο"
                      onChange={handleChange}
                      id="Εκπαιδευτικό επίπεδο"
                      value={socialHistory[7].description}  
                      >
                        <MenuItem value="Δεν γνωρίζω">Δεν γνωρίζω</MenuItem>
                        <MenuItem value="Πρωτοβάθμια">Πρωτοβάθμια</MenuItem>
                        <MenuItem value="Δευτεροβάθμια">Δευτεροβάθμια</MenuItem>
                        <MenuItem value="Τριτοβάθμια">Τριτοβάθμια</MenuItem>
                      </Select>
                    </Grid> 
                      
                    
                  
                  </Grid>
                  :
                  null    
                }

              </Grid>

          </Grid>

        </AccordionDetails>

      </Accordion>

      )
    }


    return (
      openAddPatient? 

      <CardContent className="patientMedicalHistory" style={{backgroundColor: "#f5f5f5"}} >
        <PatientDemographics/>
        <PrescriptionHistory/>
        <DistinctMedicines/>
        <DistinctTests/>
        <DocumentedVisits/>
        <Biometrics/>
        <Diagnoses/>
        <PatientAllergies/>
        <Hospitalizations/>
        <Vaccinations/>
        <FamilyHistory/>
        <SocialHistory/>
      </CardContent>
      :
      <Paper>

        <Typography variant='body1' align='center' color='textSecondary'>
        <strong>Για να μπορέσετε να αποκτήσετε πρόσβαση στο Ιατρικό ιστορικό του ασθενή, θα πρέπει να τον προσθέσετε στην ομάδα σθενών "Οι ασθενείς μου". Μπορείτε να προσθέσετε τον ασθενή επιλέγοντας το κουμπί "Ιατρικό ιστορικό" </strong>
        </Typography>
         
      </Paper>



    )
  }

  /*
  Component that records the patient history ROS and HPI
  Renders a list of inputs for the user to enter ("HpiAndMainSymptom") and a list of checkboxes ("Ros")
  */
  const PatientHisoryTake = () => {


    //Open the "PatientHisoryTake" component.
    const [openPatientHisoryTake, setOpenPatientHisoryTake] = useState(false)
    //HelpActivatedContext data the tooltips show condition
    const [helpActivatedTooltips, setHelpActivatedTooltips] = useContext(HelpActivatedContext)
    //How ROS or main symptom and HIS
    const [rosShow, setRosShow] = useState(false)
    //The potential error that might occur during data update in dexie
    const [error, setError] = useState(false)
    //The information about the symptom
    const symptomDefinition = useRef(null) 
    //The information about the review of the systems
    const ros = useRef([])



    //Open dialog
    const handleClickOpen = () => {
      setOpenPatientHisoryTake(true);
    }    
    //Close dialog
    const handleClose = () => {
      setOpenPatientHisoryTake(false)
    }


    //History of the present illness (description of the main symptom)
    const HpiAndMainSymptom = () =>{

      //The main Symptom
      const [symptom, setSymptom] = useState("")
      //The location of the symptom
      const [location, setLocation] = useState("")
      //The character of the symptom
      const [character, setCharacter] = useState("")
      //When did the symptom first manifested
      const [timeManifestation, setTimeManifestation] = useState("")
      //The duration of the manifested symptom
      const [duartionManifestation, setDurationManifestation] = useState("")
      //The context of the manifested symptom
      const [contextManifestation, setContextManifestation] = useState("")
      //The Aggravating factors of the manifested symptom
      const [aggravatingFactors, setAggravatingFactors] = useState("")
      //The Relieving factors of the manifested symptom
      const [relievingFactors, setRelievingFactors] = useState("")
      //The Relieving factors of the manifested symptom
      const [associatedSymptoms, setAssociatedSymptoms] = useState("")
      //The clinical signs
      const [clinicalSign, setClinicalSign] = useState("")
    


      //Auxiliary functions that update the state
      const onChangeLocation = (event) => {
        setLocation(event.target.value)
      }
      const onChangeCharacter = (event) => {
        setCharacter(event.target.value)
      }
      const onChangeTimeManifestation = (event) => {
        setTimeManifestation(event.target.value)
      }
      const onChangeDurationManifestation = (event) => {
        setDurationManifestation(event.target.value)
      }
      const onChangeContextManifestation = (event) => {
        setContextManifestation(event.target.value)
      }
      const onChangeAggravatingFactors = (event) => {
        setAggravatingFactors(event.target.value)
      }
      const onChangeRelievingFactors = (event) => {
        setRelievingFactors(event.target.value)
      }
      const onChangeAssociatedSymptoms = (event) => {
        setAssociatedSymptoms(event.target.value)
      }
      const onChangeSymptom = (event) => {
        setSymptom(event.target.value)
      }
      const onChangeClinicalSign = (event) => {
        setClinicalSign(event.target.value)
      }
      //Update data and move to ROS part
      const handleData = () => {

        //Update the symptoms ref
        symptomDefinition.current = {
          symptom:symptom,
          location:location,
          character:character,
          timeManifestation:timeManifestation,
          duartionManifestation:duartionManifestation,
          contextManifestation:contextManifestation,
          aggravatingFactors:aggravatingFactors,
          relievingFactors:relievingFactors,
          associatedSymptoms:associatedSymptoms,
          clinicalSigns:clinicalSign
        }
        //Move to symptoms registration
        setRosShow(true)
  
      }
      //Close dialog
      const handleCloseDialog = () => {
        setOpenPatientHisoryTake(false)
      }




      return(
        <Grid 
          container
          direction="row"
          justifyContent="center"
          alignItems="flex-start"
          spacing={1}
          className="symptom"
        >

          <Grid 
            item
            xs={12}
            md ={12}
            lg={12}
          >
          <TextField 
            onChange={onChangeSymptom} 
            autoComplete="off" 
            className={classes.textField} 
            id="Κύριο σύμπτωμα" 
            fullWidth 
            label="Κύριο σύμπτωμα" 
            value={symptom} 
            variant="outlined" 
            InputLabelProps={{shrink: true}}
            helperText="Περιγράψτε τον λόγο (σύμπτωμα) για τον οποίο σας επισκέφθηκε ο ασθενής (πχ. Πόνος στο στήθος)"
            />
          </Grid>

          <Grid 
            item
            xs={12}
            md ={6}
            lg={6}
          >
            <TextField 
            onChange={onChangeLocation} 
            autoComplete="off" 
            className={classes.textField} 
            id="Περιοχή και αντανακλάσεις" 
            fullWidth 
            label="Περιοχή και αντανακλάσεις" 
            value={location} 
            variant="outlined" 
            InputLabelProps={{shrink: true}}
            helperText="Περιγράψτε την περιοχή που εμφανίζεται το σύμπτωμα καθώς και τις αντανακλάσεις του (πχ. Προκάρδιο άλγος με αντανάκλαση στον αριστερό ώμο)"
            />
          </Grid>

          <Grid 
            item
            xs={12}
            md ={6}
            lg={6}
          >
            <TextField 
            onChange={onChangeCharacter} 
            autoComplete="off" 
            className={classes.textField} 
            id="Χαρακτήρας" 
            fullWidth 
            label="Χαρακτήρας" 
            value={character} 
            variant="outlined" 
            InputLabelProps={{shrink: true}}
            helperText="Περιγράψτε τον χαρακτήρα του συμπτώματος (πχ. Συσφιγκτικός πόνος)"
            />
          </Grid>

          <Grid 
            item
            xs={12}
            md ={6}
            lg={6}
          >
            <TextField 
            onChange={onChangeTimeManifestation} 
            autoComplete="off" 
            className={classes.textField} 
            id="Χρόνος εμφάνισης" 
            fullWidth 
            type="date"
            label="Χρόνος εμφάνισης" 
            value={timeManifestation} 
            variant="outlined" 
            InputLabelProps={{shrink: true}}
            helperText="Περιγράψτε πότε εμφανίστηκε το συμπτώμα (πχ. 23/01/2022)"
            />
          </Grid>

          <Grid 
            item
            xs={12}
            md ={6}
            lg={6}
          >
            <TextField 
            onChange={onChangeDurationManifestation} 
            autoComplete="off" 
            className={classes.textField} 
            id="Διαρκεια" 
            fullWidth 
            label="Διαρκεια" 
            value={duartionManifestation} 
            variant="outlined" 
            InputLabelProps={{shrink: true}}
            helperText="Περιγράψτε αν το σύμπτωμα ήταν διαλείπων ή συνεχόμενο καθώς και την διάρκειά του. (πχ. Συνεχόμενος πόνος διάρκειας 45 λεπτών)"
            />
          </Grid>

          <Grid 
            item
            xs={12}
            md ={6}
            lg={6}
          >
            <TextField 
            onChange={onChangeContextManifestation} 
            autoComplete="off" 
            className={classes.textField} 
            id="Συνθήκες εμφάνισης συμπτώματος" 
            fullWidth 
            label="Συνθήκες εμφάνισης συμπτώματος" 
            value={contextManifestation} 
            variant="outlined" 
            InputLabelProps={{shrink: true}}
            helperText="Περιγράψτε τις συνθήκες κάτω από τις οποίες εμφανίστηκε το σύμπτωμα. (πχ. Κατα την διάρκεια γρήγορου βαδίσματος)"
            />
          </Grid>

          <Grid 
            item
            xs={12}
            md ={6}
            lg={6}
          >
            <TextField 
            onChange={onChangeAggravatingFactors} 
            autoComplete="off" 
            className={classes.textField} 
            id="Παράγοντες επιδείνωσης συμπτώματος" 
            fullWidth 
            label="Παράγοντες επιδείνωσης συμπτώματος" 
            value={aggravatingFactors} 
            variant="outlined" 
            InputLabelProps={{shrink: true}}
            helperText="Περιγράψτε τους παράγοντες που επιδεινώνουν το σύμπτωμα. (πχ. Ανέβασμα σκάλας)"
            />
          </Grid>

          <Grid 
            item
            xs={12}
            md ={6}
            lg={6}
          >
            <TextField 
            onChange={onChangeRelievingFactors} 
            autoComplete="off" 
            className={classes.textField} 
            id="Παράγοντες βελτίωσης συμπτώματος" 
            fullWidth 
            label="Παράγοντες βελτίωσης συμπτώματος" 
            value={relievingFactors} 
            variant="outlined" 
            InputLabelProps={{shrink: true}}
            helperText="Περιγράψτε τους παράγοντες που βελτιώνουν το σύμπτωμα. (πχ. Ανάπαυση καθισμένος)"
            />
          </Grid>

          <Grid 
            item
            xs={12}
            md ={6}
            lg={6}
          >
            <TextField 
            onChange={onChangeAssociatedSymptoms} 
            autoComplete="off" 
            className={classes.textField} 
            id="Συνοδά συμπτώματα" 
            fullWidth 
            label="Συνοδά συμπτώματα" 
            value={associatedSymptoms} 
            variant="outlined" 
            InputLabelProps={{shrink: true}}
            helperText="Περιγράψτε συνοδά συμπτώματα και κλινικά σημεία που εμφανίζονται μαζί με το κύριο σύμπτωμα. (πχ. Έμετος, Ναυτία)"
            />
          </Grid>

          <Grid 
            item
            xs={12}
            md ={12}
            lg={12}
          >
            <TextField 
            onChange={onChangeClinicalSign} 
            autoComplete="off" 
            className={classes.textField} 
            id="κλινικά σημεία" 
            fullWidth 
            multiline
            maxRows={5}
            label="Κλινικά σημεία" 
            value={clinicalSign} 
            variant="outlined" 
            InputLabelProps={{shrink: true}}
            helperText="Περιγράψτε τα κλινικά σημεία που παρουσιάζει ο ασθενής"
            />
          </Grid>

          <Grid 
            item
            xs={12}
            md ={12}
            lg={12}
          >
            <Tooltip
            title= {!helpActivatedTooltips ?
            <React.Fragment>
                <Typography variant='subtitle2' color="inherit">Πατήστε "Έξοδος" για να φύγετε από τη φόρμα καταχώρησης ιστορικού.</Typography>
            </React.Fragment>
            :''} 
            >
            <Button style={{marginRight:"1rem",marginTop: window.innerWidth < 785 && "1rem"}} variant="outlined" onClick={handleCloseDialog} color="secondary">
              ΕΞΟΔΟΣ
            </Button>
            </Tooltip>
            <Tooltip
            title= {!helpActivatedTooltips ?
            <React.Fragment>
                <Typography variant='subtitle2' color="inherit">Κάντε κλικ στο "Συνέχεια" για να συνεχίσετε στην επισκόπηση συστημάτων.</Typography>
            </React.Fragment>
            :''} 
            >
            <Button className="symptom" style={{marginRight:"1rem",marginTop: window.innerWidth < 785 && "1rem"} }variant="outlined" onClick={handleData} color="primary">
              ΣΥΝΕΧΕΙΑ
            </Button>
            </Tooltip>
          </Grid>

        </Grid>
      )
    }
    //Review of systems
    const Ros = () =>{
      const setDemoMessage = useDemoStore(state => state.setDemoMessage)
      //Consider that the component is mounted
      let isMounted = true

      //Register the symptoms and ROS, update the "dexieUpdate" ref
      const handleRegister = async () => {
        setDemoMessage({
          status:true,
          severity:"info",
          description:"το κουμπί αυτό καταχωρεί το ιστορικό του ασθενή"
        })

      }
      //Return to main symptom
      const handleReturn = () => {
        setRosShow(false)
      }


      //Constitutional signs and symptoms
      const General = () => {

        const [state, setState] = useState([
          {name:" Πυρετός / Ρίγος",
          status:false
          },
          {name:" Νυχτερινή εφίδρωση",
          status:false
          },
          {name:" Κούραση / Αδυναμία",
          status:false
          },
          {name:" 'Εντονη δίψα / Διούρηση",
          status:false
          },
          {name:" Ακούσια αλλαγή βάρους",
          status:false
          },
          {name:" Υπνηλία",
          status:false
          }
        ])

        //Auxiliary function that updates the state
        const handleChange = (event) => {
          const newArr = state.map(x => {      
            if (x.name === event.target.name) {

              //Update the ROS
              if(event.target.checked){
                if(!ros.current.includes(event.target.name)){
                  ros.current.push(event.target.name)
                }
              }
              else{
                if(ros.current.includes(event.target.name)){
                  ros.current = ros.current.filter(x=> x !== event.target.name )                
                }
              }

              return {...x, status: event.target.checked};
            }
            else{
              return x
            }
          })
          setState(newArr)
        }

        return (
          <FormControl  >
            <Typography variant="h6" >
              Γενικά
            </Typography>
            <FormGroup>

              {state.map(x=>
                <FormControlLabel
                label={<Typography variant="subtitle2" color="textSecondary"> {x.name} </Typography> }
                key={x.name}
                control={
                  <Checkbox
                    checked={x.status}
                    onChange={handleChange}
                    name={x.name}
                    color="primary"
                  />
                }
                />
              )}
      
            </FormGroup>
          </FormControl>

        )
      }
      //Cardiovascular signs and symptoms
      const Cardiovascular = () => {

        const [state, setState] = useState([
          {name:" Πόνος στο στήθος ",
          status:false
          },
          {name:" Δύσπνοια",
          status:false
          },
          {name:" Πρησμένα πόδια",
          status:false
          },
          {name:" Ταχυκαρδία",
          status:false
          },
          {name:" Αρρυθμίες",
          status:false
          },
          {name:" Υπέρταση / Υπόταση",
          status:false
          },
          {name:" Τάση για λιποθυμίθα / Λιποθυμία",
          status:false
          },
          {name:" Πόνος στα πόδια κατά την βάδιση",
          status:false
          },
        ])

        //Auxiliary function that updates the state
        const handleChange = (event) => {
          const newArr = state.map(x => {
            if (x.name === event.target.name) {

              //Update the ROS
              if(event.target.checked){
                if(!ros.current.includes(event.target.name)){
                  ros.current.push(event.target.name)
                }
              }
              else{
                if(ros.current.includes(event.target.name)){
                  ros.current = ros.current.filter(x=> x !== event.target.name )                
                }
              }


              return {...x, status: event.target.checked};
            }
            else{
              return x
            }
          })
          setState(newArr)
        }

        return (
          <FormControl  >
            <Typography variant="h6" >
              Καρδιαγγειακό
            </Typography>
            <FormGroup>

              {state.map(x=>
                <FormControlLabel
                label={<Typography variant="subtitle2" color="textSecondary"> {x.name} </Typography> }
                key={x.name}
                control={
                  <Checkbox
                    checked={x.status}
                    onChange={handleChange}
                    name={x.name}
                    color="primary"
                  />
                }
                />
              )}
      
            </FormGroup>
          </FormControl>

        )
      }
      //Respiratory signs and symptoms
      const Respiratory = () => {

        const [state, setState] = useState([
          {name:" Βήχας παραγωγικός",
          status:false
          },
          {name:" Βήχας μη παραγωγικός",
          status:false
          },
          {name:" Βήχας με αίμα",
          status:false
          },
          {name:" Δύσπνοια με άσκηση",
          status:false
          },
          {name:" Δύσπνοια ξαπλωμένος",
          status:false
          },
          {name:" Συριγμός",
          status:false
          },
          {name:" Πόνος στο στήθος",
          status:false
          },
          {name:" Αφύπνηση την νύχτα με ανάγκη για αέρα",
          status:false
          },
        ])

        //Auxiliary function that updates the state
        const handleChange = (event) => {
          const newArr = state.map(x => {
            if (x.name === event.target.name) {

              //Update the ROS
              if(event.target.checked){
                if(!ros.current.includes(event.target.name)){
                  ros.current.push(event.target.name)
                }
              }
              else{
                if(ros.current.includes(event.target.name)){
                  ros.current = ros.current.filter(x=> x !== event.target.name )                
                }
              }


              return {...x, status: event.target.checked};
            }
            else{
              return x
            }
          })
          setState(newArr)
        }

        return (
          <FormControl  >
            <Typography variant="h6" >
              Αναπνευστικό
            </Typography>
            <FormGroup>

              {state.map(x=>
                <FormControlLabel
                label={<Typography variant="subtitle2" color="textSecondary"> {x.name} </Typography> }
                key={x.name}
                control={
                  <Checkbox
                    checked={x.status}
                    onChange={handleChange}
                    name={x.name}
                    color="primary"
                  />
                }
                />
              )}
      
            </FormGroup>
          </FormControl>

        )
      }
      //Gastrointestinal signs and symptoms
      const Gastrointestinal = () => {

        const [state, setState] = useState([
          {name:" Δυσφαγία",
          status:false
          },
          {name:" Ναυτία",
          status:false
          },
          {name:" 'Εμετος",
          status:false
          },
          {name:" Κοιλιακός πόνος",
          status:false
          },
          {name:" Τυμπανισμός",
          status:false
          }, 
          {name:" Δυσκοιλιότητα",
          status:false
          },
          {name:" Διάρροια",
          status:false
          },
          {name:" Κόπρανα λευκά",
          status:false
          },
          {name:" Κόπρανα κόκκινα ή βυσσινί",
          status:false
          },
          {name:" Κόπρανα μαύρα",
          status:false
          },
          {name:" Κόπρανα που επιπλέουν",
          status:false
          },
          {name:" Ίκτερος ",
          status:false
          }
        ])

        //Auxiliary function that updates the state
        const handleChange = (event) => {
          const newArr = state.map(x => {
            if (x.name === event.target.name) {

              //Update the ROS
              if(event.target.checked){
                if(!ros.current.includes(event.target.name)){
                  ros.current.push(event.target.name)
                }
              }
              else{
                if(ros.current.includes(event.target.name)){
                  ros.current = ros.current.filter(x=> x !== event.target.name )                
                }
              }


              return {...x, status: event.target.checked};
            }
            else{
              return x
            }
          })
          setState(newArr)
        }

        return (
          <FormControl  >
            <Typography variant="h6" >
              Γαστρεντερικό
            </Typography>
            <FormGroup>

              {state.map(x=>
                <FormControlLabel
                label={<Typography variant="subtitle2" color="textSecondary"> {x.name} </Typography> }
                key={x.name}
                control={
                  <Checkbox
                    checked={x.status}
                    onChange={handleChange}
                    name={x.name}
                    color="primary"
                  />
                }
                />
              )}
      
            </FormGroup>
          </FormControl>

        )
      }
      //Genitourinary signs and symptoms
      const Genitourinary = () => {

        const [state, setState] = useState([
          {name:" Πόνος στην πύελο",
          status:false
          },
          {name:" Δυσουρία",
          status:false
          },
          {name:" Συχνοουρία ",
          status:false
          },
          {name:" Αιματουρία",
          status:false
          },
          {name:" Επιτακτική ούρηση",
          status:false
          },
          {name:" Επίσχεση ούρων",
          status:false
          },
          {name:" Ακράτεια ούρων",
          status:false
          },
          {name:" Νυκτουρία ",
          status:false
          },
          {name:" Σκούρα καφέ ούρα",
          status:false
          }
        ])

        //Check if all the neccessary info are inserted to open the visit
        useEffect(() => {

      
          //If the patient is male
          if(patientInfo.generalInfo.data.sex.id === 1 ) {
            setState([...state,
              {name:"Στυτική δυσλειτουργία",
              status:false
              },
              {name:"Ορχεοδυνία  ",
              status:false
              },
              {name:"Οσχεϊκές μάζες  ",
              status:false
              },
              {name:"'Eλλειψη σεξουαλικής διάθεσης",
              status:false
              },
              {name:"Δυσπαρευνία",
              status:false
              },
              {name:"Μή φυσιολογικές πεϊκές εκκρίσεις ",
              status:false
              },
            ])
          }
          else{
            setState([...state,
              {name:"Μηνορραγία",
              status:false
              },
              {name:"Ασταθείς κύκλοι",
              status:false
              },
              {name:"Αίμα μετά την εμμηνόπαυση",
              status:false
              },
              {name:"Δυσμηνόρροια",
              status:false
              },
              {name:"Δυσπαρευνία",
              status:false
              },
              {name:"Μή φυσιολογικές κολπικές εκκρίσεις ",
              status:false
              },
            ])
          }
        },[])

        

        //Auxiliary function that updates the state
        const handleChange = (event) => {
          const newArr = state.map(x => {
            if (x.name === event.target.name) {

              //Update the ROS
              if(event.target.checked){
                if(!ros.current.includes(event.target.name)){
                  ros.current.push(event.target.name)
                }
              }
              else{
                if(ros.current.includes(event.target.name)){
                  ros.current = ros.current.filter(x=> x !== event.target.name )                
                }
              }

              
              return {...x, status: event.target.checked};
            }
            else{
              return x
            }
          })
          setState(newArr)
        }

        return (
          <FormControl  >
            <Typography variant="h6" >
              Ουροποιητικό / Αναπαραγωγικό
            </Typography>
            <FormGroup>

              {state.map(x=>
                <FormControlLabel
                label={<Typography variant="subtitle2" color="textSecondary"> {x.name} </Typography> }
                key={x.name}
                control={
                  <Checkbox
                    checked={x.status}
                    onChange={handleChange}
                    name={x.name}
                    color="primary"
                  />
                }
                />
              )}
      
            </FormGroup>
          </FormControl>

        )
      }
      //Musculoskeletal signs and symptoms
      const Musculoskeletal = () => {

        const [state, setState] = useState([
          {name:" Πόνος στα οστά",
          status:false
          },
          {name:" Πόνος / Φλεγμονή αρθρώσεων",
          status:false
          },
          {name:" Αλλοίωση αρθρώσεων",
          status:false
          },
          {name:" Μυϊκός πόνος",
          status:false
          },
          {name:" Τράυμα",
          status:false
          }
        ])

        //Auxiliary function that updates the state
        const handleChange = (event) => {
          const newArr = state.map(x => {
            if (x.name === event.target.name) {

              //Update the ROS
              if(event.target.checked){
                if(!ros.current.includes(event.target.name)){
                  ros.current.push(event.target.name)
                }
              }
              else{
                if(ros.current.includes(event.target.name)){
                  ros.current = ros.current.filter(x=> x !== event.target.name )                
                }
              }


              return {...x, status: event.target.checked};
            }
            else{
              return x
            }
          })
          setState(newArr)
        }

        return (
          <FormControl  >
            <Typography variant="h6" >
              Μυοσκελετικό
            </Typography>
            <FormGroup>

              {state.map(x=>
                <FormControlLabel
                label={<Typography variant="subtitle2" color="textSecondary"> {x.name} </Typography> }
                key={x.name}
                control={
                  <Checkbox
                    checked={x.status}
                    onChange={handleChange}
                    name={x.name}
                    color="primary"
                  />
                }
                />
              )}
      
            </FormGroup>
          </FormControl>

        )
      }
      //Neurological  signs and symptoms
      const Neurological  = () => {

        const [state, setState] = useState([
          {name:" Πονοκέφαλος",
          status:false
          },
          {name:" Μυϊκή αδυναμία",
          status:false
          },
          {name:" Παραισθησία ",
          status:false
          },
          {name:" Απώλεια μνήμης συγκέντρωσης",
          status:false
          },
          {name:" Ζάλη",
          status:false
          },
          {name:" Ιλιγγος ",
          status:false
          },
          {name:" Αταξία ",
          status:false
          },
          {name:" Λιποθυμία / Τάση για λιποθυμία",
          status:false
          },
          {name:" Τρόμος (τρέμουλο)",
          status:false
          },
          {name:" Πσράληση",
          status:false
          },
          {name:" Δυσκολία στην ομιλία / κατάποση",
          status:false
          },
          {name:" Απώλεια ισορροπίας",
          status:false
          },
          {name:" Επιληπτική κρίση",
          status:false
          }
        ])

        //Auxiliary function that updates the state
        const handleChange = (event) => {
          const newArr = state.map(x => {
            if (x.name === event.target.name) {

              //Update the ROS
              if(event.target.checked){
                if(!ros.current.includes(event.target.name)){
                  ros.current.push(event.target.name)
                }
              }
              else{
                if(ros.current.includes(event.target.name)){
                  ros.current = ros.current.filter(x=> x !== event.target.name )                
                }
              }


              return {...x, status: event.target.checked};
            }
            else{
              return x
            }
          })
          setState(newArr)
        }

        return (
          <FormControl  >
            <Typography variant="h6" >
              Νευρολογικό
            </Typography>
            <FormGroup>

              {state.map(x=>
                <FormControlLabel
                label={<Typography variant="subtitle2" color="textSecondary"> {x.name} </Typography> }
                key={x.name}
                control={
                  <Checkbox
                    checked={x.status}
                    onChange={handleChange}
                    name={x.name}
                    color="primary"
                  />
                }
                />
              )}
      
            </FormGroup>
          </FormControl>

        )
      }
      //Psychiatric  signs and symptoms
      const Psychiatric  = () => {

        const [state, setState] = useState([
          {name:" Άγχος",
          status:false
          },
          {name:" Αλλαγές θυμικού",
          status:false
          },
          {name:" Θυμός",
          status:false
          },
          {name:" Αυπνία",
          status:false
          },
          {name:" Υπνηλία",
          status:false
          },
          {name:" Ψευδαισθήσεις ",
          status:false
          },
          {name:" Ψυχαναγκασμός ",
          status:false
          },
          {name:" Αυτοκτονικές τάσεις",
          status:false
          },              
          {name:" Θύμα κοποίησης (σεξουαλική, σωματική, ψυχική )",
          status:false
          },
          
        ])

        //Auxiliary function that updates the state
        const handleChange = (event) => {
          const newArr = state.map(x => {
            if (x.name === event.target.name) {

              //Update the ROS
              if(event.target.checked){
                if(!ros.current.includes(event.target.name)){
                  ros.current.push(event.target.name)
                }
              }
              else{
                if(ros.current.includes(event.target.name)){
                  ros.current = ros.current.filter(x=> x !== event.target.name )                
                }
              }


              return {...x, status: event.target.checked};
            }
            else{
              return x
            }
          })
          setState(newArr)
        }

        return (
          <FormControl  >
            <Typography variant="h6" >
              Ψυχιατρική
            </Typography>
            <FormGroup>

              {state.map(x=>
                <FormControlLabel
                label={<Typography variant="subtitle2" color="textSecondary"> {x.name} </Typography> }
                key={x.name}
                control={
                  <Checkbox
                    checked={x.status}
                    onChange={handleChange}
                    name={x.name}
                    color="primary"
                  />
                }
                />
              )}
      
            </FormGroup>
          </FormControl>

        )
      }
      //Endocrine  signs and symptoms
      const Endocrine  = () => {

        const [state, setState] = useState([
          {name:" Έλλειψη ανοχής στο κρύο / ζέστη",
          status:false
          },
          {name:" Διαταραχές κύκλου (Γυναίκες)",
          status:false
          },
          {name:" Πολυουρία",
          status:false
          },
          {name:" Πολυδιψία",
          status:false
          },
          {name:" Πολυφαγία",
          status:false
          },
          {name:" Ξηροδερμία ",
          status:false
          },
          {name:" Αλλαγές στη σεξουαλική διάθεση",
          status:false
          }              
        ])

        //Auxiliary function that updates the state
        const handleChange = (event) => {
          const newArr = state.map(x => {
            if (x.name === event.target.name) {

              //Update the ROS
              if(event.target.checked){
                if(!ros.current.includes(event.target.name)){
                  ros.current.push(event.target.name)
                }
              }
              else{
                if(ros.current.includes(event.target.name)){
                  ros.current = ros.current.filter(x=> x !== event.target.name )                
                }
              }


              return {...x, status: event.target.checked};
            }
            else{
              return x
            }
          })
          setState(newArr)
        }

        return (
          <FormControl  >
            <Typography variant="h6" >
              Ενδοκρινολογικό
            </Typography>
            <FormGroup>

              {state.map(x=>
                <FormControlLabel
                label={<Typography variant="subtitle2" color="textSecondary"> {x.name} </Typography> }
                key={x.name}
                control={
                  <Checkbox
                    checked={x.status}
                    onChange={handleChange}
                    name={x.name}
                    color="primary"
                  />
                }
                />
              )}
      
            </FormGroup>
          </FormControl>

        )
      }
      //Integumentary  signs and symptoms
      const Integumentary  = () => {

        const [state, setState] = useState([
          {name:" Εξάνθημα",
          status:false
          },
          {name:" Αλωπεκία",
          status:false
          },
          {name:" Αλλαγές στο χρώμα του δέρματος",
          status:false
          },
          {name:" Δερματικά Έλκη",
          status:false
          },
          {name:" Κνησμός δέρματος",
          status:false
          },
          {name:" Ξηροδερμία ",
          status:false
          },
          {name:" Δυσπλαστικοί / άτυποι  σπίλοι",
          status:false
          }            
        ])

        //Auxiliary function that updates the state
        const handleChange = (event) => {
          const newArr = state.map(x => {
            if (x.name === event.target.name) {

              //Update the ROS
              if(event.target.checked){
                if(!ros.current.includes(event.target.name)){
                  ros.current.push(event.target.name)
                }
              }
              else{
                if(ros.current.includes(event.target.name)){
                  ros.current = ros.current.filter(x=> x !== event.target.name )                
                }
              }


              return {...x, status: event.target.checked};
            }
            else{
              return x
            }
          })
          setState(newArr)
        }

        return (
          <FormControl  >
            <Typography variant="h6" >
              Καλυπτήριο
            </Typography>
            <FormGroup>

              {state.map(x=>
                <FormControlLabel
                label={<Typography variant="subtitle2" color="textSecondary"> {x.name} </Typography> }
                key={x.name}
                control={
                  <Checkbox
                    checked={x.status}
                    onChange={handleChange}
                    name={x.name}
                    color="primary"
                  />
                }
                />
              )}
      
            </FormGroup>
          </FormControl>

        )
      }
      //Breast signs and symptoms
      const Breast = () => {

        const [state, setState] = useState([
          {name:" Εξογκώματα / μάζες",
          status:false
          },
          {name:" Ευαισθησία",
          status:false
          },
          {name:" Έκκρισείς της θηλής",
          status:false
          },
          {name:" Πόνος",
          status:false
          },
          {name:" Αλλοιώσεις υψηλής επικινδυνότητας",
          status:false
          }            
        ])

        //Auxiliary function that updates the state
        const handleChange = (event) => {
          const newArr = state.map(x => {
            if (x.name === event.target.name) {

              //Update the ROS
              if(event.target.checked){
                if(!ros.current.includes(event.target.name)){
                  ros.current.push(event.target.name)
                }
              }
              else{
                if(ros.current.includes(event.target.name)){
                  ros.current = ros.current.filter(x=> x !== event.target.name )                
                }
              }


              return {...x, status: event.target.checked};
            }
            else{
              return x
            }
          })
          setState(newArr)
        }

        return (
          <FormControl  >
            <Typography variant="h6" >
              Στήθος
            </Typography>
            <FormGroup>

              {state.map(x=>
                <FormControlLabel
                label={<Typography variant="subtitle2" color="textSecondary"> {x.name} </Typography> }
                key={x.name}
                control={
                  <Checkbox
                    checked={x.status}
                    onChange={handleChange}
                    name={x.name}
                    color="primary"
                  />
                }
                />
              )}
      
            </FormGroup>
          </FormControl>

        )
      }
      //Hematologic  signs and symptoms
      const Hematologic = () => {

        const [state, setState] = useState([
          {name:" Μελανιές / πετέχειες (δημιουργούνται εύκολα)",
          status:false
          },
          {name:" Αναιμία",
          status:false
          },
          {name:" Πρησμένοι λεμφαδένες",
          status:false
          },
          {name:" Συχνές ασθένειες",
          status:false
          }           
        ])

        //Auxiliary function that updates the state
        const handleChange = (event) => {
          const newArr = state.map(x => {
            if (x.name === event.target.name) {

              //Update the ROS
              if(event.target.checked){
                if(!ros.current.includes(event.target.name)){
                  ros.current.push(event.target.name)
                }
              }
              else{
                if(ros.current.includes(event.target.name)){
                  ros.current = ros.current.filter(x=> x !== event.target.name )                
                }
              }


              return {...x, status: event.target.checked};
            }
            else{
              return x
            }
          })
          setState(newArr)
        }

        return (
          <FormControl  >
            <Typography variant="h6" >
              Κυκλοφορικό / Λεμφικό
            </Typography>
            <FormGroup>

              {state.map(x=>
                <FormControlLabel
                label={<Typography variant="subtitle2" color="textSecondary"> {x.name} </Typography> }
                key={x.name}
                control={
                  <Checkbox
                    checked={x.status}
                    onChange={handleChange}
                    name={x.name}
                    color="primary"
                  />
                }
                />
              )}
      
            </FormGroup>
          </FormControl>

        )
      }
      //Eyes signs and symptoms
      const Eyes = () => {

        const [state, setState] = useState([
          {name:" Θολή όραση",
          status:false
          },
          {name:" Απώλεια όρασης",
          status:false
          },
          {name:" Πόνος στα μάτια",
          status:false
          },
          {name:" Κόκκινα μάτια",
          status:false
          },
          {name:" Πρησμένα μάτια",
          status:false
          },
          {name:" Εκκρίσεις μάτιών",
          status:false
          },
          {name:" Κνησμός",
          status:false
          },
                    
        ])

        //Auxiliary function that updates the state
        const handleChange = (event) => {
          const newArr = state.map(x => {
            if (x.name === event.target.name) {

              //Update the ROS
              if(event.target.checked){
                if(!ros.current.includes(event.target.name)){
                  ros.current.push(event.target.name)
                }
              }
              else{
                if(ros.current.includes(event.target.name)){
                  ros.current = ros.current.filter(x=> x !== event.target.name )                
                }
              }


              return {...x, status: event.target.checked};
            }
            else{
              return x
            }
          })
          setState(newArr)
        }

        return (
          <FormControl  >
            <Typography variant="h6" >
              Μάτια
            </Typography>
            <FormGroup>

              {state.map(x=>
                <FormControlLabel
                label={<Typography variant="subtitle2" color="textSecondary"> {x.name} </Typography> }
                key={x.name}
                control={
                  <Checkbox
                    checked={x.status}
                    onChange={handleChange}
                    name={x.name}
                    color="primary"
                  />
                }
                />
              )}
      
            </FormGroup>
          </FormControl>

        )
      }
      //Face signs and symptoms
      const Face = () => {

        const [state, setState] = useState([
          {name:" Απώλεια ακοής",
          status:false
          },
          {name:" Ωταλγία",
          status:false
          },
          {name:" Εκκρίσεις ωτός",
          status:false
          },
          {name:" Εμβοές",
          status:false
          },
          {name:" Ρινική συμφόρηση",
          status:false
          },
          {name:" Συνάχι ",
          status:false
          },
          {name:" Ρινορραγία",
          status:false
          },
          {name:" Πίεση στα ιγμόρεια",
          status:false
          },
          {name:" Πονόλαιμος",
          status:false
          },
          {name:" Δυσκαταποσία",
          status:false
          },
          {name:" Μάζα στο λαιμό",
          status:false
          },
          {name:" Πόνος αυχένα",
          status:false
          },
          {name:" Στοματικά έλκη",
          status:false
          },
          {name:" Λαρυγγίτιδα",
          status:false
          },
          {name:" Πόνος στο πρόσωπο / μουδιασμα",
          status:false
          },
          {name:" Πόνος στον αυχένα",
          status:false
          },
          
                    
        ])

        //Auxiliary function that updates the state
        const handleChange = (event) => {
          const newArr = state.map(x => {
            if (x.name === event.target.name) {

              //Update the ROS
              if(event.target.checked){
                if(!ros.current.includes(event.target.name)){
                  ros.current.push(event.target.name)
                }
              }
              else{
                if(ros.current.includes(event.target.name)){
                  ros.current = ros.current.filter(x=> x !== event.target.name )                
                }
              }


              return {...x, status: event.target.checked};
            }
            else{
              return x
            }
          })
          setState(newArr)
        }

        return (
          <FormControl  >
            <Typography variant="h6" >
              Πρόσωπο
            </Typography>
            <FormGroup>

              {state.map(x=>
                <FormControlLabel
                label={<Typography variant="subtitle2" color="textSecondary"> {x.name} </Typography> }
                key={x.name}
                control={
                  <Checkbox
                    checked={x.status}
                    onChange={handleChange}
                    name={x.name}
                    color="primary"
                  />
                }
                />
              )}
      
            </FormGroup>
          </FormControl>

        )
      }


      return(
        <Grid 
        container
        direction="row"
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
        className="ros"
        >

          <Grid 
          className={classes.Ros}
          item
          xs={12}
          md ={6}
          lg={4}
          >
            <General/>
          </Grid>

          <Grid 
          className={classes.Ros}
          item
          xs={12}
          md ={6}
          lg={4}
          >
            <Cardiovascular/>
          </Grid>

          <Grid 
          className={classes.Ros}
          item
          xs={12}
          md ={6}
          lg={4}
          >
            <Respiratory/>
          </Grid>

          <Grid 
          className={classes.Ros}
          item
          xs={12}
          md ={6}
          lg={4}
          >
            <Genitourinary/>
          </Grid>

          <Grid 
          className={classes.Ros}
          item
          xs={12}
          md ={6}
          lg={4}
          >
            <Gastrointestinal/>
          </Grid>

          <Grid 
          className={classes.Ros}
          item
          xs={12}
          md ={6}
          lg={4}
          >
            <Musculoskeletal/>
          </Grid>

          <Grid 
          className={classes.Ros}
          item
          xs={12}
          md ={6}
          lg={4}
          >
            <Neurological/>
          </Grid>

          <Grid 
          className={classes.Ros}
          item
          xs={12}
          md ={6}
          lg={4}
          >
            <Psychiatric/>
          </Grid>

          <Grid 
          className={classes.Ros}
          item
          xs={12}
          md ={6}
          lg={4}
          >
            <Endocrine/>
          </Grid>

          <Grid 
          className={classes.Ros}
          item
          xs={12}
          md ={6}
          lg={4}
          >
            <Integumentary/>
          </Grid>
          

          {patientInfo.generalInfo.data.sex.id === 1 ?
            null
          :
            <Grid 
            className={classes.Ros}
            item
            xs={12}
            md ={6}
            lg={4}
            >
              <Breast/>
            </Grid>
          }

          <Grid 
          className={classes.Ros}
          item
          xs={12}
          md ={6}
          lg={4}
          >
            <Hematologic/>
          </Grid>

          <Grid 
          className={classes.Ros}
          item
          xs={12}
          md ={6}
          lg={4}
          >
            <Eyes/>
          </Grid>

          <Grid 
          className={classes.Ros}
          item
          xs={12}
          md ={6}
          lg={4}
          >
            <Face/>
          </Grid>




          <Grid 
            item
            xs={12}
            md ={12}
            lg={12}
          >

            <Tooltip
            title= {!helpActivatedTooltips ?
            <React.Fragment>
                <Typography variant='subtitle2' color="inherit">Για να επιστρέψετε στην φόρμα καταχώρησης κύριου συμπτώματος, επιλέξτε το κουμπί "Επιστροφή".</Typography>
            </React.Fragment>
            :''} 
            >
            <Button style={{marginRight:"1rem",marginTop: window.innerWidth < 785 && "1rem"}} variant="outlined" onClick={handleReturn} color="secondary">
              ΕΠΙΣΤΡΟΦΗ
            </Button>
            </Tooltip>
            <Tooltip
            title= {!helpActivatedTooltips ?
            <React.Fragment>
                <Typography variant='subtitle2' color="inherit">Για να ενημερώσετε το ιστορικό του ασθενή, κάντε κλικ στο κουμπί "Καταχώρηση".</Typography>
            </React.Fragment>
            :''} 
            >
            <Button className="ros" style={{marginRight:"1rem",marginTop: window.innerWidth < 785 && "1rem"}} variant="outlined" onClick={handleRegister} color="primary">
              ΚΑΤΑΧΩΡΗΣΗ
            </Button>
            </Tooltip>
          </Grid>

        </Grid>
      )
    }

    return(
      <>
        <Tooltip
        title= {!helpActivatedTooltips ?
        <React.Fragment>
            <Typography  variant='h6' color="inherit">Καταχώρηση ιστορικού</Typography>
            <Typography variant='subtitle2' color="inherit">Για να ενημερώσετε το ιστορικό του ασθενή, κάντε κλικ στην επιλογή "Ενημέρωση ιστορικού". Θα σας ανοίξει μια φόρμα για να συμπληρώσετε το ιστορικό του.</Typography>
        </React.Fragment>
        :''} 
        >
        <Button className="takeHistory"  variant="outlined"  color="primary" onClick={handleClickOpen}>
          <Typography variant='button'>
            ΕΝΗΜΕΡΩΣΗ ΙΣΤΟΡΙΚΟΥ
          </Typography>
        </Button>
        </Tooltip>
        <Dialog
          fullWidth
          maxWidth="md"
          open={openPatientHisoryTake}
          onClose={handleClose}
        >


          <DialogTitle id="alert-dialog-title">
            {rosShow === false ? "Κύριο σύμπτωμα" : "Επισκόπηση συστημάτων"}
          </DialogTitle>

          <DialogContent>
            {rosShow === false ?
              <HpiAndMainSymptom/>
              :  
              <Ros/>   
            }
          </DialogContent>

        </Dialog>

        <Snackbar open={error} onClose={()=> setError(false) }>
          <Alert onClose={()=> setError(false)} variant='filled' severity='error' >
            Κάτι πήγε στραβά και η ενημέρωση του ιστορικού απέτυχε. Δοικιμάστε πάλι αργότερα.
          </Alert>
        </Snackbar>

      </>
    )
  }
  /*
  Component that gets activated in case of multiple insurances of the patient (AMKA to test : '01016028605' )
  Renders a dialog with a list of exeptions for the user to select
  */
  const SelectUninsuredExeptions = () =>{

    //The possible selection for the user to choose in case of an uninsured patient
    const [uninsuredSelections, setUninsuredSelections] = useState([])



    //Add "Καμία" selection to "uninsuredExeptions"
    useEffect(() => {
      const addedNone = uninsuredExeptions.filter(x=>x.isActive).concat([{description: "Καμία", id: 0, isActive: true, ordinal: 0}])
      const sorted = addedNone.sort((a,b) => a.id - b.id)
      setUninsuredSelections(sorted)
    },[uninsuredExeptions])



    //Close the "SelectUninsuredExeptions" component
    const handleOpenUninsuredExeptionsClose = (x) =>{
      setSelectedUninsuredExeption(x)
      setOpenUninsuredExeptions(false)
    }
  


    return(
        <div>
          <Dialog 
          maxWidth='sm' 
          fullWidth={true} 
          onClose={(event, reason)=>{
            if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
              setOpenUninsuredExeptions(false)
            }
          }} 
          aria-labelledby="Εξαίρεση ανασφάλιστου" 
          open={openUninsuredExeptions} 
          >
            <DialogTitle style={{textAlign: 'center'}}>Ο ασθενής είναι ανασφάλιστος. Επιλέξτε μια από τις παρακάτω κατηγορίες που ανήκει ο ασθενής. </DialogTitle>
              <Divider />
              <List>
              {uninsuredSelections.map(x => (
                <ListItem button onClick={() => handleOpenUninsuredExeptionsClose(x)} key={x.id} >
                  <ListItemAvatar >
                    <Avatar style={{backgroundColor:'#3f51b5'}}>
                    {x.id + 1}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primaryTypographyProps = {{variant:'subtitle2', color:'textPrimary'}}  primary = {x.description}   />  
                </ListItem>))}
              </List>
          </Dialog>        
        </div> 
    )

  }
  /*
  Component that that presents to the user the visit options
  Renders a card with the visit reason and other
  */
  const VisitOptions = () =>{

    //The visit id
    const [visitId, setVisitId] = useContext(VisitIdContext)
    //Thje selected unit
    const [selectedUnit] = useContext(UnitContext)
    //The visit reason
    const [vistReason, setVistReason] = useState("")
    //The visit comment
    const [comment, setComment] = useState("")
    //Enables/Disables the open visit button
    const [disableOpenVisit, setDisableOpenVisit] = useState(true)
    //Opens the selection Options
    const [selectionOptionsOpen, setSelectionOptionsOpen] = useState(false)
    //Inform the user that the proccess of opening the visit is underway
    const [loadingOpenVisit, setLoadingOpenVisit] = useState(false)
    //Inform the user that the proccess updating patient clinical card failed
    const [updateError, setUpdateError] = useState({
      status:false,
      data:""
    })
    //The chosen uninsured exeption in case on an auninsured patient
    const [selectedUninsuredExeption, setSelectedUninsuredExeption] = useContext(uninsuredExeptionChosenContext)
    //Proactive status
    const [proactive, setProactive] = useContext(ProactiveContext)
    //Enables/Disables the override dialog
    const [visitOverride, setVisitOverride] = useState({
      status:false,
      info:null
    })
    //Shows or hides the tooltip dialog
    const [openHelp, setOpenHelp] = useState(false)
    //HelpActivatedContext data the tooltips show condition
    const [helpActivatedTooltips, setHelpActivatedTooltips] = useContext(HelpActivatedContext)
    //Holds the pediatric age exeption information (if true we must send root "1.80.7")
    const pediatricAgeExeptionRef = useRef({status:false, reason:""})
    //The selected ovveride reason for overrides (ex. pediatric / hospitalization)
    const generalOverrideReasonRef = useRef(null)
    //A set of predefined selection for the "visit reason". Used to help the user
    const selection = [
      { title: "Φαρμακευτική συνταγή", code: 1 },
      { title: "Εξέταση", code: 2 },
      { title: "Παραπεμπτικό εξετάσεων", code: 3 },
      { title: "Φαρμακευτική συνταγή και παραπεμπτικό εξετάσεων", code: 4 },
    ]
    //The abborter for the openVisit() call
    const abortControllerOpenVisit = useRef(null)
    //Consider that the component is mounted
    let isMounted = true

    const navigate = useNavigate()


    //Check if all the neccessary info "vistReason" are inserted to open the visit
    useEffect(() => {
      if(vistReason) {
        setDisableOpenVisit(false)
      }
      else{
        setDisableOpenVisit(true)
      }
    })
    //Load the help tooltip after 1 second
    useEffect(()=>{
      setTimeout(() => steps.status && setOpenHelp(true) , 1000) 
    },[]) 

   

    //Try to open proactive visit
    async function openProactiveVisit() {
      
      try{

        


        //Start loading
        setLoadingOpenVisit(true)

        //API call to get the patient info
        const response = await fetch(process.env.REACT_APP_API_URL1 + '/refferals/proactiveVisit' ,{ 
        method: 'post',
        headers: {"Content-Type": "application/json", "authorization" : data.token},     
        body: JSON.stringify({
            amka:patientInfo.generalInfo.data.amka,
            unitId:selectedUnit.id,
            proactiveCampaignId:proactive.data.proactiveCampaignId
          })
        })
        if(response.ok){

          const responseData = await response.json()

          if(responseData.error){
            throw(responseData)
          }
          else{
            //Stop loading
            setLoadingOpenVisit(false)
            setVisitId(responseData.visitId)
            navigate("/ReferralPage")

          }
        }
        else{
          throw('response status 400')
        }
      }
      catch (error) {
        //Stop loading
        setLoadingOpenVisit(false)
        const userInfoErrorReporting = JSON.parse(localStorage.getItem('errorContactInfo'))===true ?{
          doctorSpecialty:data.data.User.doctorSpecialty.name,
          email:data.data.User.email,
          mobile:data.data.User.mobile,
          firstname:data.data.User.name.firstname,
          lastname:data.data.User.name.lastname
        }:null
        rollbar.error("Error in 'openProactiveVisit()' in PatientPage in ERx-React",{error:error, user:userInfoErrorReporting}) 
        console.log(error)
        setGeneralInfo({
          status:true,
          severity:'error',
          info:"Κάτι πήγε στραβά και η επίσκεψη δεν άνοιξε. Δοκιμάστε πάλι αργότερα."
        })
      }
      
    }

    //Opens the visit
    async function openVisit() {
      try{


        //Start loading
        setLoadingOpenVisit(true)
        //Close override dialog
        setVisitOverride({status:false, info:null})

        abortControllerOpenVisit.current = new AbortController()
        const id = setTimeout(() => abortControllerOpenVisit.current.abort("autoAborted"), parseInt(process.env.REACT_APP_TIMEOUT_MULTIPLIER) * 6000)    
        const response = {
          status: 200,
          json: () => Promise.resolve({
            success: true,
            info: {
              componentOf: {
                encompassingEncounter: {
                  id: [{ extension: "123456789" }]
                }
              }
            }
          })
        };     
        clearTimeout(id)

 

     


        //Reset the 'generalOverrideReasonRef' ref (IMPORTANT!!! so the API can make the right call). ATTENTION do not reset 'pediatricAgeExeptionRef' beacuse it is nedde to send the 1.80.7 root in xml
        generalOverrideReasonRef.current = null
    

        //If the response succesfull
        if(response.status===200){
          const openVisitRes = await response.json()


          //If everytghing ok
          if(openVisitRes.success){
            setVisitId(openVisitRes.info.componentOf.encompassingEncounter.id[0].extension)
            navigate("/PrescriptionPage")
          }
          else if(openVisitRes.info === 6018){
            //Show error to user
            setGeneralInfo({
              status:true,
              severity:'error',
              info:"Η μονάδα συνταγογράφησης που επιλέξατε δεν σμφωνεί με την διεύθυνση IP της συνδεσής σας. Επιλέξτε διαφορετική μονάδα συνταγογράφησης."
            })
          }
          else if(openVisitRes.info === 6023){
            //Show error to user
            setGeneralInfo({
              status:true,
              severity:'error',
              info:"Δεν μπορείτε να συνταγογραφήσετε για το συγκεκριμένο ασφαλιστικό φορέα"
            })
          }
          else if(openVisitRes.info === 425){
            //Show error to user
            setGeneralInfo({
              status:true,
              severity:'error',
              info:"Υπάρχει ήδη ανοιχτή επίσκεψη. Για να επιλυθεί το πρόβλημα επιστρέψτε στην κεντρική σελίδα."
            })
          }
          else if(openVisitRes.info === 1893){
            //Check if we need to send root 1.80.7 in xml (pediatric fek acceptance) Open override dialog
            setVisitOverride({
              status:true,
              info:{
                id:123456789, // the id is a custom created one to identify the FEK acceptance
                reasons:{
                  reason:[]
                }
              },
              responseInfo:openVisitRes
            })
          }
          else if(openVisitRes.info === 6036){

            //Get overrideReasons and open the Override dialog
            const overrideReasons = overrideData.find(x=>x.id===openVisitRes.overrideData.overrideTypeId)
            //Open override dialog
            setVisitOverride({
              status:true,
              info:overrideReasons,
              responseInfo:openVisitRes
            })
          }
          else if(openVisitRes.info === 6055){
            //Get getHospitalizedOverrideReasons and open the Override dialog
            const hospitalizedOverrideReasons = overrideData.find(x=>x.id===9)
            //Open override dialog
            setVisitOverride({
              status:true,
              info:hospitalizedOverrideReasons,
              responseInfo:openVisitRes
            })
          }
          else{
            //Show error to user
            setGeneralInfo({
              status:true,
              severity:'error',
              info:"Κάτι πήγε στραβά και η επίσκεψη δεν άνοιξε. Δοκιμάστε πάλι αργότερα"
            })
          }
        }
        //If the response failed
        else{
          throw(`openVisit response status : ${response.status}`)
        }


        //Stop loading
        setLoadingOpenVisit(false)
      }   
      catch (error) {
        //DO NOT Show the error to the user in case the user has manually aborted the call or has unmounted the component.In any other case DO SHOW the error.  
        if( (error.name === 'AbortError' && abortControllerOpenVisit.current.signal.reason !== "autoAborted") === false ){
          //Send error to backend
          const userInfoErrorReporting = JSON.parse(localStorage.getItem('errorContactInfo'))===true ?{
            doctorSpecialty:data.data.User.doctorSpecialty.name,
            email:data.data.User.email,
            mobile:data.data.User.mobile,
            firstname:data.data.User.name.firstname,
            lastname:data.data.User.name.lastname
          }:null
          rollbar.error("Error in 'openVisit()' in PatientPage in ERx-React",{error:error, user:userInfoErrorReporting}) 
          //Show error to user
          setGeneralInfo({
            status:true,
            severity:'error',
            info:"Κάτι πήγε στραβά και η επίσκεψη δεν άνοιξε. Δοκιμάστε πάλι αργότερα."
          })
          //Stop loading
          setLoadingOpenVisit(false)
        }
      }
    }
    //Update the comment
    const handleChangeComment = (event) => {
      setComment(event.target.value);
    }
    //Update the reason
    const handleChangeReason = (event) => {

      if(selectionOptionsOpen){
        setSelectionOptionsOpen(false) 
      }
      
      setVistReason(event.target.value)

    }
    //Return the user to the "MainPage" (x==="/MainPage") or move to prescriptions (x==="/PrescriptionPage")
    const movePageUser = async (x) => {

      try{

        
        
        //Conditional navigation
        if(x === "/MainPage"){
          abortOpenVisit()
          navigate("/MainPage")
        }
        else if(x === "/PrescriptionPage"){
          openVisit()
        }
        else{
          navigate("/MainPage")
        }
        

      }
      catch (error) {
        //Send error to backend
        const userInfoErrorReporting = JSON.parse(localStorage.getItem('errorContactInfo'))===true ?{
          doctorSpecialty:data.data.User.doctorSpecialty.name,
          email:data.data.User.email,
          mobile:data.data.User.mobile,
          firstname:data.data.User.name.firstname,
          lastname:data.data.User.name.lastname
        }:null
        rollbar.error("Error in 'movePageUser()' in PatientPage in ERx-React",{error:error, user:userInfoErrorReporting})

        //If the component is still mounted
        if (isMounted) {
          //Show error to user
          setUpdateError({
            status:true,
            data:x
          })
        }
      }
    }
    //Close the error snackbar and move the user
    const handleClose = ()=> {


      //Conditional navigation
      if(updateError.data === "/MainPage"){
        navigate("/MainPage")
      }
      else if(updateError.data === "/PrescriptionPage"){
        openVisit()
      }


    }
    //Aborts the openVisit()
    function abortOpenVisit (){
      if(abortControllerOpenVisit.current){ 
        abortControllerOpenVisit.current.abort("user")
      }
    }
    //Updates tghe selected reason
    const handleReasonSelect = (y) => {
      setVistReason(y)
      setSelectionOptionsOpen(false)
    }


    /*Component (Dialog) to open the visit in case of override
    Important notice: There's a new way to record overrides in HDIKA. 
    The system now differentiates between hospitalization and other types of overrides. 
    For pediatric patients over 16, a specific root will be recorded 1.80.7 (see custom override "123456789"). 
    A new feature allows for flexible XML handling based on the override (selection or free text)"
    */
    const OverrideVisit = () =>{

      //The selected ovveride reason
      const [overrideReason, setOverrideReason] = useState(generalOverrideReasonRef.current)

    

    

      //Close the component and reset overrides
      const handleClose = ()=>{
        setVisitOverride({
          status:false,
          info:null
        })
        //Reset the overrides
        generalOverrideReasonRef.current=null
        pediatricAgeExeptionRef.current ={
          status:false, 
          reason:""
        }
      }
      //Update the reason
      const handleChange = (event) => {
        setOverrideReason(event.target.value)
        const selection = visitOverride.info.hasMasterData && (visitOverride.info.reasons.reason.length ? visitOverride.info.reasons.reason : [visitOverride.info.reasons.reason]).find(x=>x.id===event.target.value)
        generalOverrideReasonRef.current = visitOverride.info.hasMasterData ? {...selection, overrideId:visitOverride.info.id, overrideDescription:visitOverride.info.description} : {overrideId:visitOverride.responseInfo.overrideData.overrideTypeId, value:event.target.value, overrideDescription:visitOverride.responseInfo.overrideData.violationDetails, id:null}
      }
      //Update the pediatric FEK selection
      const handleChangePediatricFek = (event) => {
        setOverrideReason(event.target.value)
        pediatricAgeExeptionRef.current={
          status:true, 
          reason:event.target.value
        }
      }

     

 

   
    

      return(
        visitOverride.status &&
        <Dialog 
        onClose={handleClose}
        aria-labelledby="Υπερβάσεις επίσκεψης" 
        open={visitOverride.status} 
        BackdropProps={{ onClick: handleClose }}
        >
          {visitOverride.info.id===9 ?
          <React.Fragment>
          
            <DialogTitle>Έλεγχος νοσηλείας ασθενή</DialogTitle>

            <Divider />
            
            <DialogContent>

              <DialogContentText >
                <Typography variant='subtitle2'>
                  Ο ασθενής {patientInfo.generalInfo.data.lastName + " " + patientInfo.generalInfo.data.firstName} εμφανίζεται σε νοσηλεία.
                  Για να ανοίξετε την επίσκεψη θα πρέπει να αποδεχτείτε την υπέρβαση. 
                  Πατώντας το ΑΝΟΙΓΜΑ και επιλέγοντας μια υπέρβαση, αποδέχεστε την υπέρβαση νοσηλείας.
                </Typography>
              </DialogContentText>


              <TextField
              fullWidth
              select
              label="Παράκαμψη νοσηλείας ασθενή"
              id="overrideReason"
              value={overrideReason}
              onChange={handleChange}
              variant="outlined"
              >
                {(visitOverride.info.reasons.reason.length ? visitOverride.info.reasons.reason : [visitOverride.info.reasons.reason]).map(x=><MenuItem style={{ whiteSpace: 'normal', overflow: 'hidden', textOverflow: 'ellipsis' }} key={x.id} value={x.id}>{x.description}</MenuItem>)}
              </TextField>

            </DialogContent>

            <DialogActions>
              <Button onClick={handleClose} variant="outlined" color="secondary">
                ΕΠΙΣΤΡΟΦΗ
              </Button>
              <Button disabled={(overrideReason!==null ? false : true) || loadingOpenVisit } variant="outlined" onClick={()=> openVisit()} color="primary">
                {loadingOpenVisit ? "ΦΟΡΤΩΣΗ..." : "ΑΝΟΙΓΜΑ"}
              </Button>
          </DialogActions>

          </React.Fragment>
          :
          visitOverride.info.id===123456789 ?
          <React.Fragment>
            
            <DialogTitle>Έλεγχος παιδιάτρων</DialogTitle>

            <Divider />
            
            <DialogContent>

              <DialogContentText >
                <Typography variant='subtitle2'>
                  Εμπίπτει ο/η ασθενής {patientInfo.generalInfo.data.lastName + " " + patientInfo.generalInfo.data.firstName} στις εξαιρέσεις ασθενών χρονίων νοσημάτων (ΦΕΚ 4698/τ Β’/19 10 2018 και ΦΕΚ 39/τ Β’/17 1 2018) ;
                </Typography>
              </DialogContentText>


              <TextField
              fullWidth
              select
              id="overrideReason"
              value={overrideReason}
              onChange={handleChangePediatricFek}
              variant="outlined"
              >
                <MenuItem  key={1} value="1">NAI</MenuItem>
                <MenuItem  key={2} value="0">OXI</MenuItem>
              </TextField>

            </DialogContent>

            <DialogActions>
              <Button onClick={handleClose} variant="outlined" color="secondary">
                ΕΠΙΣΤΡΟΦΗ
              </Button>
              <Button disabled={(overrideReason!==null ? false : true) || loadingOpenVisit } variant="outlined" onClick={()=>openVisit()} color="primary">
                {loadingOpenVisit ? "ΦΟΡΤΩΣΗ..." : "ΑΝΟΙΓΜΑ"}
              </Button>
          </DialogActions>

          </React.Fragment>
          :
          <React.Fragment>
          
            <DialogTitle>Υπέρβαση επίσκεψης</DialogTitle>

            <Divider />
            
            <DialogContent>

              <DialogContentText >
                <Typography variant='subtitle2'>
                  {visitOverride.responseInfo.overrideData.violationDetails}
                  Για να προχωρήσετε στην επίσκεψη, {visitOverride.info.hasMasterData ? 'επιλέξτε μια αιτιολογία υπέρβασης' : 'πληκτρολογήστε την αιτιολογία υπέρβασης'} και πατήστε "Άνοιγμα". Με αυτόν τον τρόπο, αποδέχεστε την υπέρβαση.
                </Typography>
              </DialogContentText>

              {visitOverride.info.hasMasterData ?
              <TextField
              fullWidth
              select
              label="Αιτιολογία υπέρβασης"
              id="overrideReason"
              value={overrideReason}
              onChange={handleChange}
              variant="outlined"
              >
                {(visitOverride.info.reasons.reason.length ? visitOverride.info.reasons.reason : [visitOverride.info.reasons.reason]).map(x=><MenuItem  key={x.id} style={{ whiteSpace: 'normal', overflow: 'hidden', textOverflow: 'ellipsis' }} value={x.id}>{x.description}</MenuItem>)}
              </TextField>
              :
              <TextField
              fullWidth
              inputProps={{ autoComplete: 'off' }}
              label="Αιτιολογία υπέρβασης"
              id="overrideReason"
              value={overrideReason}
              onChange={handleChange}
              variant="outlined"
              />
              }

            </DialogContent>

            <DialogActions>
              <Button onClick={handleClose} variant="outlined" color="secondary">
                ΕΠΙΣΤΡΟΦΗ
              </Button>
              <Button disabled={(overrideReason!==null ? false : true) || loadingOpenVisit } variant="outlined" onClick={()=>openVisit()} color="primary">
                {loadingOpenVisit ? "ΦΟΡΤΩΣΗ..." : "ΑΝΟΙΓΜΑ"}
              </Button>
          </DialogActions>

          </React.Fragment>
        }

        </Dialog>        
      )
    }

    const setDemoMessage = useDemoStore(state => state.setDemoMessage)

    return(
      !openedVisit ?
      <>

        <OverrideVisit/>
             
        <Card className={classes.card}>
          <CardHeader
          className={classes.cardHeader}
          title={<strong>Επιλογές επίσκεψης</strong>}
          />

          

          <CardContent className ="visitReason">
            <Grid
            container
            spacing={1}
            direction="row"
            alignItems="flex-start"
            >

              <Grid item lg={6} xs={12}>       
                <Tooltip
                title= {!helpActivatedTooltips ?
                <React.Fragment>
                    <Typography  variant='h6' color="inherit">Λόγος επίσκεψης</Typography>
                    <Typography variant='subtitle2' color="inherit">Για να ξεκινήσετε μια επίσκεψη, πρέπει να επιλέξετε ή να γράψετε τον λόγο για τον οποίο ο ασθενής επισκέπτεται τον γιατρό.</Typography>
                </React.Fragment>
                :''} 
                >
                  <TextField
                  required
                  className="visitReasonText"
                  label="Λόγος επίσκεψης"
            
                  autoComplete="off"
                  value={vistReason}
                  onChange={handleChangeReason}
                  onClick = {()=>  patientInfo.patientMostUsed.updated && setSelectionOptionsOpen(true)}
                  variant="outlined"
                  fullWidth={true}
                  
                  />
                </Tooltip>
                  
                  {selectionOptionsOpen &&
                  <ClickAwayListener onClickAway={()=> setSelectionOptionsOpen(false) }>
                    <Paper  elevation={3}  variant="outlined">
                      <List  dense>
                        {selection.map(x=>
                          <ListItem key={x.code} dense button onClick={()=>handleReasonSelect(x.title)}> 
                            <ListItemText primaryTypographyProps={{variant:"subtitle2", color:"textPrimary"}} primary={x.title}/>
                          </ListItem>
                        )}
                      </List>
                    </Paper>
                  </ClickAwayListener>
                  }
                

              </Grid>
           
              <Grid item lg={6} xs={12}>  
                <Tooltip
                title= {!helpActivatedTooltips ?
                <React.Fragment>
                    <Typography  variant='h6' color="inherit">Σχόλιο επίσκεψης</Typography>
                    <Typography variant='subtitle2' color="inherit">Μπορείτε να εισαγάγετε ένα προαιρετικό σχόλιο σχετικά με την επίσκεψη.</Typography>
                </React.Fragment>
                :''} 
                >
                  <TextField
                  disabled={proactive.status}
                  id="Σχόλιο επίσκεψης"
                  className="visitComment"
                  label="Σχόλιο επίσκεψης"
                  autoComplete="off"
                  value={comment}
                  onChange={handleChangeComment}
                  variant="outlined"
                  fullWidth={true}
                  />
                </Tooltip>
              </Grid>

              <CardActions> 
               <Tooltip
                title= {!helpActivatedTooltips ?
                <React.Fragment>
                    <Typography variant='subtitle2' color="inherit">Κάνοντας κλικ στην "Επιστροφή", θα επιστρέψετε στην αρχική σελίδα.</Typography>
                </React.Fragment>
                :''} 
                >
                  <Button className="returnMainPage" onClick={()=>movePageUser("/MainPage")} variant="contained" color="secondary">
                    ΕΠΙΣΤΡΟΦΗ
                  </Button>
                </Tooltip>
                <Tooltip
                title= {!helpActivatedTooltips ?
                <React.Fragment>
                    <Typography variant='subtitle2' color="inherit">Κάντε κλικ στην επιλογή "Άνοιγμα" για να καταχωρήσετε την επίσκεψη του ασθενή σας. Στη συνέχεια, θα μεταφερθείτε στη σελίδα συνταγογράφησης, όπου μπορείτε να καταχωρήσετε τα φάρμακα που χρειάζονται.</Typography>
                </React.Fragment>
                :''} 
                >
                  {proactive.status ?
                  <Button className="openVisit" onClick={()=>  openProactiveVisit() } variant="contained" color="primary">
                    ΑΝΟΙΓΜΑ ΠΡΟΛΗΠΤΙΚΗΣ ΔΡΑΣΗΣ
                  </Button>
                  :
                  <Button className="openVisit" onClick={()=>  movePageUser("/PrescriptionPage") } variant="contained" color="primary">
                    ΑΝΟΙΓΜΑ
                  </Button>
                  } 
                 
                </Tooltip>
              </CardActions>  
              <CardActions> 

                <PatientHisoryTake/>

                <Tooltip
                title= {!helpActivatedTooltips ?
                <React.Fragment>
                    <Typography variant='subtitle2' color="inherit">Κάντε κλικ στην επιλογή "ΑΔΕΙΕΣ" για να υποβάλετε αίτηση για αναρρωτική άδεια για τον ασθενή σας. Θα μεταφερθείτε στη σελίδα Γνώμάτευσης αδειών της ΗΔΙΚΑ.</Typography>
                </React.Fragment>
                :'Κάντε κλικ στην επιλογή "ΑΔΕΙΕΣ" για να υποβάλετε αίτηση για αναρρωτική άδεια για τον ασθενή σας. Θα μεταφερθείτε στη σελίδα Γνώμάτευσης αδειών της ΗΔΙΚΑ.' } 
                >
                  <Button onClick={()=>   
        setDemoMessage({
          status:true,
          severity:"info",
          description:"το κουμπί αυτό ανοιγει την σελίδα για την καταχώρηση των αναρρωτικών αδειών"
        })
       } variant="outlined" color="primary">
                    ΑΔΕΙΕΣ
                  </Button>
                </Tooltip>

              </CardActions>          
            </Grid>
          </CardContent>
          
        </Card>

        <Snackbar open={updateError.status} onClose={handleClose}>
          <Alert onClose={handleClose} variant='filled' severity='error'>
            Κάτι πήγε στραβά και οι πληροφορίες του ασθενή δεν ενημερώθηκαν
          </Alert>
        </Snackbar>

      </> 
      :
      <div style={{marginTop:"3rem"}}>
        <Grid
        container
        spacing={1}
        direction="row"
        justifyContent="flex-end"
        alignItems="flex-end"
        >
          <Grid item>
            <PatientHisoryTake/>
          </Grid>
          <Grid item>
            <Tooltip
            title= {!helpActivatedTooltips ?
            <React.Fragment>
                <Typography variant='subtitle2' color="inherit">Πατήστε το κουμπί για να μεταβείτε στη σελίδα καταχώρισης φαρμάκων και εξετάσεων.</Typography>
            </React.Fragment>
            :''} 
            >
              <Button color="primary" variant="outlined" onClick={()=>navigate("/PrescriptionPage")}>
                ΕΠΙΣΤΡΟΦΗ ΣΤΗ ΣΥΝΤΑΓΟΓΡΑΦΗΣΗ
              </Button>
            </Tooltip>
          </Grid>
        </Grid>
      </div>
   )
  }
  
  /*
    Component that gets activated in case of military insurance and the prescription unit is NOT a military unit
    Renders a Dialog to inform the user
  */
  const InformMilitary = () =>{

    //Close the component
    function handleClose() {
      setInfoMilitaryActivate({
        status:false,
        userInformed:true
      })
    }

    
  

    return(
      <Dialog 
      onClose={()=>handleClose()}
      aria-labelledby="military dialog" 
      open={infoMilitaryActivate.status} 
      >
        <DialogTitle style={{textAlign: 'center'}}>
          Απαραίτητη χρήση Γνωμάτευσης
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Συνταγογράφηση των άμεσα ασφαλισμένων του ΥΠ.ΕΘ.Α. (εν ενεργεία στρατιωτικοί) διενεργείται
            από ιατρούς στρατιωτικής μονάδας, στρατιωτικού νοσοκομείου ή σε τμήμα επειγόντων περιστατικών κρατικού νοσοκομείου. 
            Σε κάθε άλλη περίπτωση συνταγογράφηση διενεργείται μόνο κατόπιν βεβαίωσης/παραπομπής από ιατρό στρατιωτικής μονάδας. 
            Η συνταγογράφηση στα έμμεσα μέλη ασφαλισμένων  του ΥΠ.ΕΘ.Α. καθώς και η συνταγογράφηση  από οδοντίατρους και γυναικολόγους εξαιρείται από τον παραπάνω κανόνα .
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' color='primary' onClick={handleClose}>OK</Button>
        </DialogActions>
      </Dialog>        
    )
  }


  
  //Open demographics Info
  const handlePatienInfoShow = () => {
    if(showInfo.patientInfo === false){
      setShowInfo({
        patientInfo:true,
        medicinesHistory:false,
        clinicalData:false,
        description: "Πληροφορίες ασφαλισμένου"
      })
    }
  }
  //Open medicine history Info
  const handleMedicineInfoShow = () => {

    if(showInfo.medicinesHistory === false){
      //If there is NO info about the patient history ... load the data
      if(patientHistoryByDoctor.status===false){
        getPatientHistory(true)
      }
    }
   

    setShowInfo({
      patientInfo:false,
      medicinesHistory:true,
      clinicalData:false,
      description: "Ιστορικό συνταγογράφησης (Ιατρού)"
    })
  }
  //Open Clinical history form
  const handleClinicalDataShow = () => {
    setOpenAddPatient(dummyRegularPatient);
    setAddPatient(true)
    

    if(showInfo.clinicalData === false){
      setShowInfo({
        patientInfo:false,
        medicinesHistory:false,
        clinicalData:true,
        description:"Ιστορικό ασθενή"
      })
    }
  }

  const Title = () => {
    return (
      
      <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      >

        <Grid item xs={12} sm={8} md={8} lg={9} xl={10}>
          <Typography variant='h5'>
            <strong>{showInfo.description}</strong>
          </Typography>
        </Grid>

        
     
        <Grid item >

          <Tooltip title= {!helpActivatedTooltips ?
          <React.Fragment>
              <Typography  variant='h6' color="inherit">Πληροφορίες ασθενή</Typography>
              <Typography variant='subtitle2' color="inherit">Για να δείτε τις βασικές πληροφορίες του ασθενή που αναζητήσατε, κάντε κλικ στο εικονίδιο. </Typography>
          </React.Fragment>
          :''} 
          >
            <Button className="patientMainInfo" style={{marginRight:"1rem",marginTop: window.innerWidth < 785 && "1rem",backgroundColor: showInfo.patientInfo ? "#c5cae9" : "#7986cb"}} variant="contained" onClick={handlePatienInfoShow}>
              <Person style={{fontSize: 27,color:"#FFFFFF"}}/>
            </Button>
          </Tooltip>

          <Tooltip title= {!helpActivatedTooltips ?
          <React.Fragment>
              <Typography  variant='h6' color="inherit">Ιστορικό φαρμάκων και εξετάσεων</Typography>
              <Typography variant='subtitle2' color="inherit">Κάντε κλικ στο εικονίδιο για να σας δείξει όλα τα φάρμακα και τις εξετάσεις που έχετε καταχωρήσει στον ασθενή, ταξινομημένα ανά ημερομηνία.</Typography>
          </React.Fragment>
          :''} 
          >
            <Button disabled={patientHistoryByDoctor.loading} className="patientPrescriptionHistory" style={{marginRight:"1rem",marginTop: window.innerWidth < 785 && "1rem",backgroundColor: showInfo.medicinesHistory ? "#c5cae9" : "#7986cb"}} variant="contained" onClick={handleMedicineInfoShow}>
              <FaFilePrescription style={{fontSize: 27,color:"#FFFFFF"}}/>
            </Button>
          </Tooltip>

         
          <Tooltip title= {!helpActivatedTooltips ?
          <React.Fragment>
              <Typography  variant='h6' color="inherit">Ιατρικό ιστορικό</Typography>
              <Typography variant='subtitle2' color="inherit">Για να δείτε το σύντομο ιατρικό ιστορικό του ασθενούς, κάντε κλικ στο εικονίδιο.</Typography>
          </React.Fragment>
          :''} 
          >
            <Button disabled={patientHistoryByDoctor.loading } className="patientMedicalHistory" style={{marginRight:"1rem",marginTop: window.innerWidth < 785 && "1rem",backgroundColor: showInfo.clinicalData ? "#c5cae9" : "#7986cb"}} variant="contained" onClick={handleClinicalDataShow}>
              <FaFileMedicalAlt style={{fontSize: 27,color:"#FFFFFF"}}/>
            </Button>
          </Tooltip>
          
        </Grid>

      </Grid>
    );
  }


  return (

    logged===true ?

          <div style={{ margin:'1rem'}}> 

            <HelperPoper/>

        
            
            

            {selectedInsurance ? <SelectUninsuredExeptions/> : null}

            <InformMilitary/>


            <CardHeader
              className={classes.cardHeader}
              title={<Title/>}
            />


            <Collapse in={showInfo.patientInfo}>
              <PatientInfo/>
            </Collapse>

            <Collapse in={showInfo.medicinesHistory}>
              <PatientPrescriptionHistory/>
            </Collapse>

            <Collapse in={showInfo.clinicalData}>
              <PatientMedicalHistory/>
            </Collapse>

            <VisitOptions/>

            <Info/>

            <DemoMessage/>
          
          </div> 

    : 
    <Navigate to="/"/>
  )
}

export const PatientPage = () => {

  const setDemoDialog = useDemoStore(state => state.setDemoDialog)
  const newVisit = useStore(state => state.newVisit);

  useEffect(() => {

    if(!newVisit){
      setDemoDialog({
        status:true,
        description:<>
        <Typography variant="subtitle2" gutterBottom fontWeight="bold">
          Στη σελίδα πληροφοριών ασθενούς, έχετε πρόσβαση σε τρεις βασικές λειτουργίες:
        </Typography>
        
        <List>
        <ListItem>
            <ListItemText 
              primary={
                <Typography variant="subtitle2">
                  <span style={{ fontWeight: 'bold' }}>1. Nέα επίσκεψη:</span> Να δημιουργήσετε μια νέα επίσκεψη για τον ασθενή, όπου μπορείτε να καταχωρήσετε συνταγές, φάρμακα, εξετάσεις και παραπεμπτικά (Άνοιγμα νέας επίσκεψης μέσω του κουμπιού κάτω αριστερά)
                </Typography>
              }
            />
          </ListItem>
          <ListItem>
            <ListItemText 
              primary={
                <Typography variant="subtitle2">
                  <span style={{ fontWeight: 'bold' }}>2. Πληροφορίες ασθενούς:</span> Να δείτε όλες τις σημαντικές πληροφορίες για τον ασθενή, από τα δημογραφικά του στοιχεία έως το πλήρες ιατρικό ιστορικό. Το ιατρικό ιστορικό δημιουργείται αυτόματα από το κρατικό σύστημα ηλεκτρονικής συνταγογράφησης και είναι πλήρως παραμετροποιήσιμο. (Πρόσβαση μέσω των κουμπιών πάνω δεξιά)
                </Typography>
              }
            />
          </ListItem>
          <ListItem>
            <ListItemText 
              primary={
                <Typography variant="subtitle2">
                  <span style={{ fontWeight: 'bold' }}>3. Διαχείριση ιατρικού ιστορικού:</span> Να διαχειριστείτε το ιατρικό ιστορικό του ασθενούς, προσθέτοντας αναλυτικές σημειώσεις, ενημερώνοντας τις πληροφορίες και παρακολουθώντας την πορεία της υγείας του. (Ενημέρωση ιστορικού μέσω του κουμπιού κάτω αριστερά)
                </Typography>
              }
            />
          </ListItem>

        </List>
      </>
      })
    }

  
  }, [])

  return(
    <Provider config={rollbarConfig}>
      <ErrorBoundary fallbackUI={FallbackUI}>
        <PatientPageChild/>
        <DemoDialog/>
        <PrescriptionDashboard/>
      </ErrorBoundary>
    </Provider>
  )
}